// Role Data for Modals
const roleData = {
    host: {
        title: 'Host Wildcard',
        icon: 'building-2',
        outcome: 'Transform your space into a cultural destination',
        whatThisDoes: [
            'Create a signature cultural moment that defines your venue',
            'Engage audiences through interactive prompts, gameplay, and dialogue',
            'Build lasting community connections beyond the event'
        ],
        included: [
            'Interactive exhibition system (all contributions added to cultural archive)',
            'Vibes & Virtues gameplay and Vibe Token economy',
            'Digital artifact portal integration',
            'Full facilitation and materials',
            'Optional: Live music integration (when space allows)',
            'Optional: VibeLink network activation',
            'Marketing and promotional materials'
        ],
        formats: ['One-night activation', 'Multi-day experience', 'Full city activation'],
        idealFor: 'Galleries, museums, cultural institutions, creative districts, universities, team-building and corporate events',
        pricing: 'Investment varies based on scale, format, and customization. Schedule a meeting to discuss pricing tailored to your vision.',
        urgency: 'Limited number of cities selected for 2026 tour',
        cta: 'Request Details',
        portalNote: 'Receive a post-event cultural insight summary based on participant responses',
        color: 'from-blue-600 to-indigo-600'
    },
    sponsor: {
        title: 'Sponsor the Experience',
        icon: 'hand-heart',
        outcome: 'Connect your brand to cultural innovation and community impact',
        whatThisDoes: [
            'Align with meaningful cultural programming and shape community dialogue',
            'Enable free community participation while building authentic brand connection',
            'Gain access to cultural insights, media, and engaged community contacts'
        ],
        included: [
            'Brand integration in physical experience and digital portal',
            'Brand representation on physical Vibe Tokens',
            'Help shape questions and dialogue prompts',
            'Access to attendee email and contact list',
            'Access to cultural archive and insights',
            'All media, photos, and press representation',
            'Co-marketing across activation channels'
        ],
        formats: ['City-level sponsor', 'Event sponsor', 'Portal sponsor'],
        idealFor: 'Cultural brands, foundations, community-focused organizations',
        pricing: 'Sponsorship investment is flexible and customized to your goals and integration level. Let us discuss what works for your brand.',
        urgency: 'Early partners shape the foundation of the Wildcard archive',
        cta: 'Explore Partnership',
        color: 'from-purple-600 to-pink-600'
    },
    vibelink: {
        title: 'Join VibeLink',
        icon: 'map-pin',
        outcome: 'Drive revenue while becoming part of a citywide cultural movement',
        whatThisDoes: [
            'Increase sales through QR-based discount prompts and Vibe Token redemption',
            'Drive foot traffic from Wildcard attendees (all partners promoted at experience)',
            'Build lasting community engagement and brand visibility'
        ],
        included: [
            'QR code system for discounts and engagement prompts',
            'Vibe Token redemption setup (redeemable for your products/services)',
            'Promotion to all Wildcard attendees',
            'VibeLink partner designation and marketing materials',
            'Mini-activation hosting opportunities',
            'Network visibility across the city'
        ],
        formats: ['Token partner', 'Mini-activation host', 'Network hub'],
        idealFor: 'Restaurants, lounges, cafes, local businesses, community spaces, vendors',
        pricing: 'Partnership investment is flexible and tailored to your business goals. Let us find what works for you.',
        urgency: 'Partner spots limited per city to maintain network quality',
        cta: 'Join Network',
        learnMoreLink: true,
        color: 'from-amber-500 to-orange-600'
    },
    'live-experience': {
        title: 'Integrate Live Music',
        icon: 'mic-2',
        outcome: 'Weave music into the Wildcard experience',
        whatThisDoes: [
            'Music emerges from the themes explored in the experience',
            "Performances adapt to the room's energy and reflections",
            'Transforms reflection into something you can feel'
        ],
        included: [
            'Theme-based musical performances',
            'Carey Fountain + collaborating artists',
            'Integration with puzzle themes',
            'Sonic response to the experience',
            'Sound system coordination',
            'Performance documentation'
        ],
        formats: ['Integrated with full Wildcard', 'Standalone performance', 'Multi-night series'],
        idealFor: 'Venues with music capabilities, cultural institutions, festivals',
        pricing: "Integration depends on space, format, and technical capabilities. Let's discuss what works for your venue.",
        urgency: 'Available in select formats',
        cta: 'Explore Integration',
        color: 'from-red-500 to-rose-600'
    },
    vendor: {
        title: 'Become a Vendor/Partner',
        icon: 'shopping-bag',
        outcome: 'Offer products or services redeemable with Vibe Tokens',
        whatThisDoes: [
            'Provide goods or services that attendees can redeem using Vibe Tokens',
            'Connect with engaged community members seeking authentic experiences',
            'Build brand visibility through the Wildcard network'
        ],
        included: [
            'Vibe Token redemption setup',
            'Promotion to all Wildcard attendees',
            'Marketing materials and vendor designation',
            'Network visibility',
            'Payment processing for token redemptions'
        ],
        formats: ['Product vendor', 'Service provider', 'Experience partner'],
        idealFor: 'Vendors, artists, small businesses, brands',
        pricing: 'Partnership terms are flexible and tailored to your offerings. Let us discuss what works for you.',
        urgency: 'Vendor spots available on rolling basis',
        cta: 'Apply to Join',
        color: 'from-green-500 to-emerald-600'
    }
};

let formSource = 'Website';
window.openRoleModal = (role, source = 'Direct') => {
    formSource = source;
    const data = roleData[role];
    if (!data) return;

    const modal = document.getElementById('role-panel-modal');
    const content = document.getElementById('role-panel-content');
    const inner = document.getElementById('role-modal-inner');

    if (!inner) return;

    let html = `
        <!-- Header -->
            <div class="mb-[32px] animate-fadeInDown">
            <i data-lucide="${data.icon}" class="w-[48px] h-[48px] mb-[16px] text-white"></i>
            <h2 class="font-garamond text-[36px] md:text-[48px] text-white mb-[8px] leading-tight">${data.title}</h2>
            <p class="text-[20px] text-gray-300 font-garamond italic">${data.outcome}</p>
        </div>

        <!-- What This Does For You -->
        <div class="mb-[32px] animate-fadeIn" style="animation-delay: 0.1s; opacity: 0;">
            <h3 class="text-[12px] uppercase tracking-wider mb-[16px] font-bold text-white">What this does for you</h3>
            <ul class="space-y-[12px]">
                ${data.whatThisDoes.map((item, idx) => `
                    <li class="flex items-start gap-[12px] animate-fadeInRight" style="animation-delay: ${0.2 + idx * 0.1}s; opacity: 0;">
                        <i data-lucide="sparkles" class="w-[16px] h-[16px] text-yellow-500 flex-shrink-0 mt-[4px]"></i>
                        <span class="text-[15px] text-gray-200">${item}</span>
                    </li>
                `).join('')}
            </ul>
        </div>

        <!-- What's Included -->
        <div class="mb-[32px] bg-zinc-900/50 border border-white/10 p-[24px] rounded-[12px] animate-fadeIn" style="animation-delay: 0.4s; opacity: 0;">
            <h3 class="text-[12px] uppercase tracking-wider mb-[16px] font-bold text-white">What's included</h3>
            <div class="grid md:grid-cols-2 gap-x-[32px] gap-y-[12px]">
                ${data.included.map((item, idx) => `
                    <div class="flex items-start gap-[8px] animate-fadeIn" style="animation-delay: ${0.5 + idx * 0.05}s; opacity: 0;">
                        <i data-lucide="chevron-right" class="w-[16px] h-[16px] text-blue-400 flex-shrink-0 mt-[2px]"></i>
                        <span class="text-[13px] text-gray-300">${item}</span>
                    </div>
                `).join('')}
            </div>
        </div>

        <!-- Format Options -->
        <div class="mb-[32px] animate-fadeIn" style="animation-delay: 0.6s; opacity: 0;">
            <h3 class="text-[12px] uppercase tracking-wider mb-[16px] font-bold text-white">Format options</h3>
            <div class="flex flex-wrap gap-[12px]">
                ${data.formats.map((format, idx) => `
                    <div class="px-[20px] py-[8px] bg-blue-900/20 border border-blue-500/50 rounded-[9999px] text-[12px] font-medium text-white animate-scaleIn" style="animation-delay: ${0.7 + idx * 0.1}s; opacity: 0;">
                        ${format}
                    </div>
                `).join('')}
            </div>
        </div>

        <!-- Ideal For -->
        <div class="mb-[32px] animate-fadeIn" style="animation-delay: 0.8s; opacity: 0;">
            <h3 class="text-[12px] uppercase tracking-wider mb-[8px] font-bold text-white">Ideal for</h3>
            <p class="text-[14px] text-gray-400 leading-relaxed">${data.idealFor}</p>
        </div>

        <!-- Investment/Sponsorship -->
        <div class="mb-[24px] bg-zinc-900/30 border-l-[4px] border-green-500 p-[20px] rounded-r-[8px] animate-fadeIn" style="animation-delay: 0.9s; opacity: 0;">
            <div class="flex items-start gap-[16px]">
                <i data-lucide="dollar-sign" class="w-[24px] h-[24px] text-green-500 flex-shrink-0 mt-[4px]"></i>
                <div>
                    <h3 class="text-[15px] font-bold text-white mb-[4px]">
                        ${role === 'sponsor' ? 'Sponsorship' : 'Investment'}
                    </h3>
                    <p class="text-[14px] text-gray-300 leading-relaxed">${data.pricing}</p>
                </div>
            </div>
        </div>

        <!-- Urgency -->
        <div class="mb-[32px] bg-zinc-900/30 border-l-4 border-red-500 p-[20px] rounded-r-lg animate-fadeIn" style="animation-delay: 1s; opacity: 0;">
            <div class="flex items-start gap-[16px]">
                <i data-lucide="clock" class="w-[24px] h-[24px] text-red-500 flex-shrink-0 mt-[4px]"></i>
                <div class="flex items-center">
                    <p class="text-[14px] text-gray-300 font-medium">${data.urgency}</p>
                </div>
            </div>
        </div>

        <!-- Social Proof for Hosts -->
        ${role === 'host' ? `
            <div class="mb-[32px] bg-zinc-900/50 border border-white/10 p-[24px] rounded-[12px] animate-fadeIn" style="animation-delay: 1.1s; opacity: 0;">
                <h3 class="text-[14px] uppercase tracking-wider mb-[16px] font-bold text-white">Why venues choose Wildcard</h3>
                <div class="space-y-[24px]">
                    <div class="border-l-2 border-blue-500 pl-4">
                        <p class="text-[14px] text-gray-300 italic mb-[8px] leading-relaxed">
                            "Wildcard transformed our gallery into a living, breathing community hub. People stayed for hours, truly engaged. It wasn't just an event—it became a cultural moment for our city."
                        </p>
                        <p class="text-[12px] text-gray-500">— Cultural Director, Birmingham Arts Space</p>
                    </div>
                    <div class="grid grid-cols-3 gap-[16px] pt-6 border-t border-white/10">
                        <div class="text-center">
                            <div class="text-[24px] font-bold text-blue-400 mb-[4px]">500+</div>
                            <div class="text-[10px] text-gray-500 uppercase tracking-tighter">Average Attendees</div>
                        </div>
                        <div class="text-center">
                            <div class="text-[24px] font-bold text-green-400 mb-[4px]">3-4 hrs</div>
                            <div class="text-[10px] text-gray-500 uppercase tracking-tighter">Avg. Engagement</div>
                        </div>
                        <div class="text-center">
                            <div class="text-[24px] font-bold text-yellow-500 mb-[4px]">85%</div>
                            <div class="text-[10px] text-gray-500 uppercase tracking-tighter">Would Return</div>
                        </div>
                    </div>
                </div>
            </div>
        ` : ''}

        <!-- Portal Note for Hosts -->
        ${role === 'host' && data.portalNote ? `
            <div class="mb-[32px] bg-purple-900/10 border border-purple-500/30 rounded-[8px] p-[16px] animate-fadeIn" style="animation-delay: 1.2s; opacity: 0;">
                <p class="text-[13px] text-gray-300 italic flex items-center gap-[12px]">
                    <i data-lucide="globe" class="w-[16px] h-[16px] text-purple-400 flex-shrink-0"></i>
                    ${data.portalNote}
                </p>
            </div>
        ` : ''}

        <!-- Social Proof for Sponsors -->
        ${role === 'sponsor' ? `
            <div class="mb-[32px] bg-zinc-900/50 border border-white/10 p-[24px] rounded-[12px] animate-fadeIn" style="animation-delay: 1.1s; opacity: 0;">
                <h3 class="text-[14px] uppercase tracking-wider mb-[16px] font-bold text-white">Impact beyond the event</h3>
                <div class="space-y-[16px]">
                    <div class="flex items-start gap-[12px] animate-fadeIn" style="animation-delay: 1.2s; opacity: 0;">
                        <i data-lucide="sparkles" class="w-[16px] h-[16px] text-yellow-500 flex-shrink-0 mt-[4px]"></i>
                        <p class="text-[14px] text-gray-300">Your brand becomes part of a permanent cultural archive, with contributions living on digitally</p>
                    </div>
                    <div class="flex items-start gap-[12px] animate-fadeIn" style="animation-delay: 1.3s; opacity: 0;">
                        <i data-lucide="sparkles" class="w-[16px] h-[16px] text-yellow-500 flex-shrink-0 mt-[4px]"></i>
                        <p class="text-[14px] text-gray-300">Direct access to engaged community members who value cultural participation</p>
                    </div>
                    <div class="flex items-start gap-[12px] animate-fadeIn" style="animation-delay: 1.4s; opacity: 0;">
                        <i data-lucide="sparkles" class="w-[16px] h-[16px] text-yellow-500 flex-shrink-0 mt-[4px]"></i>
                        <p class="text-[14px] text-gray-300">Authentic integration through meaningful dialogue, not traditional advertising</p>
                    </div>
                </div>
            </div>
        ` : ''}

        <!-- Learn More Link for VibeLink -->
        ${role === 'vibelink' ? `
            <div class="mb-[24px] text-center animate-fadeIn" style="animation-delay: 1.1s; opacity: 0;">
                <a href="https://vibelink.wildcard.com" target="_blank" class="inline-flex items-center gap-[8px] text-purple-400 hover:text-purple-300 transition-colors underline">
                    Click here to learn more about VibeLink
                    <i data-lucide="chevron-right" class="w-[16px] h-[16px]"></i>
                </a>
            </div>
        ` : ''}

        <button onclick="startFormFlow('${role}')" class="w-full bg-white text-black py-4 text-[14px] font-bold rounded-[12px] hover:bg-gray-100 transition-all shadow-xl animate-fadeIn" style="animation-delay: 1.5s; opacity: 0;">
            ${data.cta}
        </button>
    `;

    inner.innerHTML = html;
    console.log(inner);
    modal.classList.remove('hidden');
    setTimeout(() => {
        content.classList.remove('scale-95', 'opacity-0');
        content.classList.add('scale-100', 'opacity-100');
    }, 10);

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    if (typeof lucide !== 'undefined') lucide.createIcons({ root: inner });
};

window.closeRoleModal = () => {
    const modal = document.getElementById('role-panel-modal');
    const content = document.getElementById('role-panel-content');
    const inner = document.getElementById('role-modal-inner');
    
    // Purge resources immediately to drop RAM frame-buffers before transition completes on memory-constrained mobile browsers
    if (inner) {
        inner.querySelectorAll('img, video, iframe').forEach(el => {
            el.src = '';
            el.removeAttribute('src');
            if (typeof el.load === 'function') el.load();
        });
    }

    content.classList.remove('scale-100', 'opacity-100');
    content.classList.add('scale-95', 'opacity-0');
    setTimeout(() => {
        modal.classList.add('hidden');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        if (inner) inner.innerHTML = ''; // FREE UP MEMORY!
    }, 500);
};

window.updateRoleSelection = (role) => {
    const buttons = document.querySelectorAll('.role-selector-btn');
    buttons.forEach(btn => {
        const btnOnClick = btn.getAttribute('onclick') || '';
        if (btnOnClick.includes(`'${role}'`)) {
            btn.classList.add('active');
        } else {
            btn.classList.remove('active');
        }
    });

    if (role === 'host' || role === 'sponsor' || role === 'vibelink' || role === 'vendor') {
        window.openRoleModal(role);
        return;
    }

    // Standard scrolling for other roles
    let targetId = '';
    switch (role) {
        case 'attend': targetId = 'what-happens'; break;
        case 'all': targetId = 'experience-selector'; break;
    }

    if (targetId) {
        const element = document.getElementById(targetId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
};

// Enhanced reveal system
const initReveals = () => {
    const revealCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('active');
                observer.unobserve(entry.target);
            }
        });
    };

    const revealObserver = new IntersectionObserver(revealCallback, {
        root: null,
        threshold: 0.05,
        rootMargin: '0px'
    });

    const elements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale, .reveal-top');
    elements.forEach(el => revealObserver.observe(el));

    // Fallback: If elements are in view on load, trigger them
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight) {
            el.classList.add('active');
        }
    });
};

const sampleResponses = [
    'Home is where I learned resilience...',
    'My city taught me strength...',
    'Love kept us going when...',
    'Real patriotism requires honesty...',
    'Failure taught me to try again...',
    'She taught me that power is quiet...',
    'What if education prepared us for freedom?',
    'Solidarity requires showing up...',
    'My neighborhood shaped who I am...',
    'Community means being seen...',
];

let dataStreamInterval = null;
const startDataStream = () => {
    const container = document.getElementById('data-stream-container');
    if (!container || dataStreamInterval) return;

    const isMobile = window.innerWidth < 1024;
    const intervalTime = isMobile ? 6000 : 2500;

    dataStreamInterval = setInterval(() => {
        const text = sampleResponses[Math.floor(Math.random() * sampleResponses.length)];
        const item = document.createElement('div');
        item.className = 'absolute text-[10px] md:text-[12px] text-purple-300/70 italic font-mono whitespace-nowrap pointer-events-none data-stream-item';
        item.innerText = text;

        const x = Math.random() * 80 + 10; // 10-90%
        item.style.left = `${x}%`;
        item.style.bottom = '-40px';

        container.appendChild(item);

        // Remove after animation
        setTimeout(() => {
            item.remove();
        }, 10000);
    }, intervalTime);
};

const stopDataStream = () => {
    if (dataStreamInterval) {
        clearInterval(dataStreamInterval);
        dataStreamInterval = null;
    }
};

const initDataStream = () => {
    const container = document.getElementById('data-stream-container');
    if (!container) return;
    container._startAutoplay = startDataStream;
    container._stopAutoplay = stopDataStream;
};

window.toggleVolume = (container) => {
    const video = container.closest('.relative').querySelector('video');
    const icon = container.querySelector('.vol-icon');

    // Mute all other videos first
    document.querySelectorAll('video.main-video').forEach(v => {
        if (v !== video) {
            v.muted = true;
            const otherIcon = v.closest('.relative').querySelector('.vol-icon');
            if (otherIcon) {
                otherIcon.setAttribute('data-lucide', 'volume-x');
            }
        }
    });

    if (video.muted) {
        video.muted = false;
        icon.setAttribute('data-lucide', 'volume-2');
    } else {
        video.muted = true;
        icon.setAttribute('data-lucide', 'volume-x');
    }

    if (typeof lucide !== 'undefined') {
        const slider = document.getElementById('video-slider');
        lucide.createIcons({ root: slider || btn.closest('.relative') || document.body });
    }
};

const initVideoSlider = () => {
    const videoSlider = document.getElementById('video-slider');
    const indicators = document.querySelectorAll('.indicator');
    let isDown = false;
    let startX;
    let scrollLeft;

    if (videoSlider) {
        videoSlider.addEventListener('mousedown', (e) => {
            isDown = true;
            videoSlider.classList.add('active');
            startX = e.pageX - videoSlider.offsetLeft;
            scrollLeft = videoSlider.scrollLeft;
            videoSlider.style.scrollSnapType = 'none';
        });

        videoSlider.addEventListener('mouseleave', () => {
            isDown = false;
            videoSlider.style.scrollSnapType = 'x mandatory';
        });

        videoSlider.addEventListener('mouseup', () => {
            isDown = false;
            videoSlider.style.scrollSnapType = 'x mandatory';
        });

        videoSlider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - videoSlider.offsetLeft;
            const walk = (x - startX) * 2;
            videoSlider.scrollLeft = scrollLeft - walk;
        });

        videoSlider.addEventListener('scroll', () => {
            const sliderRect = videoSlider.getBoundingClientRect();
            const slides = videoSlider.querySelectorAll('.snap-center');
            let minDiff = Infinity;
            let activeIndex = 0;

            slides.forEach((slide, i) => {
                const slideRect = slide.getBoundingClientRect();
                const diff = Math.abs((slideRect.left + slideRect.width / 2) - (sliderRect.left + sliderRect.width / 2));
                if (diff < minDiff) {
                    minDiff = diff;
                    activeIndex = i;
                }
            });

            indicators.forEach((ind, i) => {
                if (i === activeIndex) {
                    ind.classList.add('bg-red-500', 'w-[32px]');
                    ind.classList.remove('bg-white/30', 'w-[8px]');
                } else {
                    ind.classList.remove('bg-red-500', 'w-[32px]');
                    ind.classList.add('bg-white/30', 'w-[8px]');
                }
            });
        });
    }

    window.scrollVideos = (direction) => {
        if (!videoSlider) return;
        const slides = videoSlider.querySelectorAll('.snap-center');
        let currentIndex = 0;
        let minDiff = Infinity;
        const sliderRect = videoSlider.getBoundingClientRect();

        slides.forEach((slide, i) => {
            const slideRect = slide.getBoundingClientRect();
            const diff = Math.abs((slideRect.left + slideRect.width / 2) - (sliderRect.left + sliderRect.width / 2));
            if (diff < minDiff) {
                minDiff = diff;
                currentIndex = i;
            }
        });

        let targetIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;
        if (targetIndex >= 0 && targetIndex < slides.length) {
            slides[targetIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    };
};

const initDynamicPromptSlider = () => {
    const container = document.getElementById('dynamic-cards-wrapper');
    const cards = document.querySelectorAll('.dynamic-card');
    const dots = document.querySelectorAll('.progress-dot');
    if (!cards.length) return;

    let currentIndex = 0;
    let interval;

    const equalizeHeights = () => {
        if (!container || !cards.length) return;

        container.style.minHeight = '0px';
        let maxHeight = 0;

        cards.forEach(card => {
            const originalStyle = card.getAttribute('style') || '';

            // Set styles for measurement
            card.style.display = 'block';
            card.style.position = 'relative';
            card.style.visibility = 'hidden';
            card.style.opacity = '0';
            card.style.transition = 'none';
            card.style.transform = 'none';

            const height = card.scrollHeight;
            if (height > maxHeight) maxHeight = height;

            // Restore original style
            if (originalStyle) {
                card.setAttribute('style', originalStyle);
            } else {
                card.removeAttribute('style');
            }
        });

        if (maxHeight > 0) {
            container.style.minHeight = `${maxHeight + 20}px`; // Add some buffer
        }
    };

    // Run measurement with multiple timing fallbacks to account for font/asset loading
    equalizeHeights();
    setTimeout(equalizeHeights, 500);
    setTimeout(equalizeHeights, 2000);
    window.addEventListener('resize', equalizeHeights);
    window.addEventListener('load', equalizeHeights);

    const showCard = (index) => {
        cards.forEach((card, i) => {
            if (i === currentIndex) {
                card.classList.remove('active');
                card.classList.add('exit');
                setTimeout(() => {
                    card.classList.remove('exit');
                    card.style.display = 'none';
                }, 500);
            }
        });

        currentIndex = index;

        const nextCard = cards[currentIndex];
        nextCard.style.display = 'block';
        // Force reflow
        nextCard.offsetHeight;
        nextCard.classList.add('active');

        dots.forEach((dot, i) => {
            dot.classList.toggle('active', i === currentIndex);
            dot.classList.toggle('w-[32px]', i === currentIndex);
            dot.classList.toggle('w-[8px]', i !== currentIndex);
        });
    };

    const nextPrompt = () => {
        const nextIndex = (currentIndex + 1) % cards.length;
        showCard(nextIndex);
    };

    const startInterval = () => {
        if (interval) return;
        interval = setInterval(nextPrompt, 4000);
    };

    const stopInterval = () => {
        clearInterval(interval);
        interval = null;
    };

    dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
            stopInterval();
            showCard(i);
            startInterval();
        });
    });

    container._startAutoplay = startInterval;
    container._stopAutoplay = stopInterval;
};

const initSystemMap = () => {
    const svg = document.getElementById('system-svg');
    const modal = document.getElementById('system-modal');
    const modalContent = document.getElementById('system-modal-content');
    const modalInner = document.getElementById('modal-inner-content');

    const instInitial = document.getElementById('instruction-initial');
    const instProgress = document.getElementById('instruction-progress');
    const instComplete = document.getElementById('instruction-complete');
    const remainingCount = document.getElementById('remaining-count');
    const progressDots = document.getElementById('map-progress-dots');

    if (!svg) return;

    const nodes = [
        {
            id: 'exhibition',
            color: '#ef4444',
            icon: 'puzzle',
            gif: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Step_3__also_include_in_the_build_mural_node_media_upload.gif?v=1778826678',
            title: 'Build the Mural',
            desc: 'Add puzzle pieces through participation and collective action. Watch the full picture come together in real time.',
            bullets: ['Contribute through prompts and interactive installations', 'See your piece become part of the larger artwork', 'Watch the collective picture emerge'],
            note: 'Each piece continues beyond the exhibition through the Artifact Portal',
            link: 'Explore the Puzzle Artworks',
            linkUrl: 'https://vibesandvirtues.com/pages/landing#puzzle-artworks'
        },
        {
            id: 'card-game',
            color: '#f59e0b',
            icon: 'layers',
            gif: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Step_4_use__also_include_in_the_play_the_card_game_node_media_upload.gif?v=1778826754',
            title: 'Play the Card Game',
            desc: "Sit down, read the room, and test your intuition. This isn't just conversation—it's strategy.",
            bullets: ["Lead player asks a Question Card from their hand", "Everyone answers YES or NO secretly (face down)", "Lead player guesses each person's answer", "Reveal cards — correct guesses stay face up"],
            note: 'Players can bet Vibe Tokens when placing their YES/NO card. Lead player can match the bet before guessing.',
            link: 'Explore the Card Game',
            linkUrl: 'https://vibesandvirtues.com/collections/card-game-decks'
        },
        {
            id: 'live-experience',
            color: '#3b82f6',
            icon: 'mic-2',
            gif: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Step_5__also_include_in_the_live_music_integration_media_upload_node.gif?v=1778826824',
            title: 'Live Music Integration',
            desc: 'In select formats, live music is woven into the experience—emerging from the themes in real time.',
            bullets: ['Music is tied to each puzzle theme', 'Performers integrate audience responses into live sets', 'A dynamic soundscape that evolves with the mural'],
            note: 'Integration depends on venue capabilities, format type, and experience goals.',
            link: 'Explore the Music',
            linkUrl: 'https://vibesandvirtues.com/pages/about-carey-music'
        },
        {
            id: 'tokens',
            color: '#22c55e',
            icon: 'coins',
            gif: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Step_6__also_include_in_the_vibe_tokens_media_upload_node.gif?v=1778826897',
            title: 'Earn Vibe Tokens',
            desc: 'Every interaction earns tokens. Spend them to influence the environment or unlock new experiences.',
            bullets: ['Earn tokens for honesty and participation', 'Use tokens to select the next musical vibe', 'Trade tokens for exclusive artifact access'],
            note: 'Earn and redeem beyond the event through the Portal',
            isEconomy: true
        },
        {
            id: 'vibelink',
            color: '#a855f7',
            icon: 'map-pin',
            gif: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/VibeLink.gif?v=1778826979',
            title: 'VibeLink: Ongoing Venue Engagement',
            desc: 'A standalone subscription service that continually engages customers and increases revenue. Perfect for bars, restaurants, lounges, and hospitality spaces.',
            bullets: ['QR-based customer engagement system', 'Increased dwell time and customer spending', 'Real-time customer interaction and connection', 'Token rewards that drive return visits'],
            note: 'VibeLink operates independently from Wildcard events.',
            link: 'Launch VibeLink Experience',
            linkUrl: 'https://vest-mug-66210004.figma.site'
        },
        {
            id: 'beyond-the-room',
            color: '#ec4899',
            icon: 'globe',
            gif: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/artifact_portal.gif?v=1778831994',
            title: 'Beyond the Room',
            desc: "Your participation continues after the event through the Artifact Portal.",
            bullets: ['Your responses become part of a growing archive', 'Continue engaging with prompts after the night', 'See how your community perspectives evolve over time'],
            note: 'What happens in the room doesn\'t stay in the room. This is a system.',
            link: 'Explore the Portal Experience',
            linkUrl: 'https://artifact.vibesandvirtues.com'
        }
    ];

    const exploredNodes = new Set();
    let activeNodeId = null;

    const updateInstructions = () => {
        const total = nodes.length;
        const explored = exploredNodes.size;

        if (explored === 0) {
            instInitial.classList.remove('hidden');
            instProgress.classList.add('hidden');
            instComplete.classList.add('hidden');
            progressDots.classList.add('opacity-0');
        } else if (explored < total) {
            instInitial.classList.add('hidden');
            instProgress.classList.remove('hidden');
            instComplete.classList.add('hidden');
            remainingCount.textContent = total - explored;
            progressDots.classList.remove('opacity-0');
        } else {
            instInitial.classList.add('hidden');
            instProgress.classList.add('hidden');
            instComplete.classList.remove('hidden', 'flex');
            instComplete.classList.add('flex');
            triggerConfetti();
        }

        // Update dots
        const dots = progressDots.querySelectorAll('[data-dot]');
        dots.forEach((dot, i) => {
            if (i < explored) {
                dot.classList.remove('bg-gray-600');
                dot.classList.add('bg-yellow-400', 'shadow-lg', 'shadow-yellow-400/50', 'scale-125');
            } else {
                dot.classList.add('bg-gray-600');
                dot.classList.remove('bg-yellow-400', 'shadow-lg', 'shadow-yellow-400/50', 'scale-125');
            }
        });
    };

    const triggerConfetti = () => {
        if (window.confettiInterval) return;
        const container = document.getElementById('token-flow-container');
        for (let i = 0; i < 50; i++) {
            const confetti = document.createElement('div');
            confetti.className = 'absolute w-[12px] h-[12px] rounded-[9999px] pointer-events-none opacity-0';
            const colors = ['#ef4444', '#f59e0b', '#3b82f6', '#22c55e', '#a855f7'];
            confetti.style.backgroundColor = colors[i % colors.length];
            confetti.style.left = '50%';
            confetti.style.top = '30%';
            container.appendChild(confetti);

            const angle = Math.random() * Math.PI * 2;
            const velocity = 5 + Math.random() * 10;
            const tx = Math.cos(angle) * (200 + Math.random() * 400);
            const ty = Math.sin(angle) * (200 + Math.random() * 400);

            confetti.animate([
                { transform: 'translate(0, 0) scale(0)', opacity: 1 },
                { transform: `translate(${tx}px, ${ty}px) scale(1)`, opacity: 1, offset: 0.7 },
                { transform: `translate(${tx}px, ${ty + 200}px) scale(0.5)`, opacity: 0 }
            ], {
                duration: 2000 + Math.random() * 1000,
                easing: 'ease-out',
                delay: i * 20
            });
        }
        window.confettiInterval = true;
    };

    // Use the global openSystemModal for all nodes
    const openModal = (node) => {
        openSystemModal(node.id);
    };

    // Attach listeners to pre-rendered nodes
    document.querySelectorAll('.system-node-group').forEach((nodeEl, idx) => {
        const nodeId = nodeEl.getAttribute('data-node-id');
        const node = nodes.find(n => n.id === nodeId);

        // Stagger delays
        const line = nodeEl.querySelector('.system-line');
        const nodeCircle = nodeEl.querySelector('.node-circle');
        if (line) line.style.animationDelay = `${idx * 0.1}s`;
        if (nodeCircle) nodeCircle.style.animationDelay = `${0.2 + idx * 0.1}s`;

        if (node) {
            nodeEl.addEventListener('click', () => {
                // Celebration Ring Effect
                const circle = nodeEl.querySelector('.node-circle');
                if (circle) {
                    const cx = circle.getAttribute('cx');
                    const cy = circle.getAttribute('cy');
                    const ring = document.createElementNS("http://www.w3.org/2000/svg", "circle");
                    ring.setAttribute("cx", cx);
                    ring.setAttribute("cy", cy);
                    ring.setAttribute("r", "50");
                    ring.setAttribute("fill", "none");
                    ring.setAttribute("stroke", node.color);
                    ring.setAttribute("stroke-width", "2");
                    ring.setAttribute("class", "celebration-ring");
                    svg.appendChild(ring);
                    setTimeout(() => ring.remove(), 600);
                }

                // Remove active class from all nodes first
                document.querySelectorAll('.system-node-group').forEach(el => el.classList.remove('active'));
                nodeEl.classList.add('active');

                openModal(node);
            });
        }
    });

    updateInstructions();
};

const initCardGlow = () => {
    const cards = document.querySelectorAll('.step-card');
    cards.forEach((card, i) => {
        const glow = card.querySelector('.step-glow');
        const content = card.querySelector('.step-content');

        const delay = `${i * 0.2}s`;
        if (glow) glow.style.animationDelay = delay;
        if (content) content.style.animationDelay = delay;
    });
};

const initArtifactPortal = () => {
    const display = document.getElementById('artifact-step-display');
    const dots = document.querySelectorAll('.artifact-portal-dot');
    const labels = document.querySelectorAll('.artifact-portal-label');
    if (!display) return;

    const steps = [
        { title: 'Engage in the Experience', description: 'Puzzle piece interaction, people writing responses', icon: 'sparkles' },
        { title: 'Share Your Perspective', description: 'Handwritten responses lifting off the wall', icon: 'message-circle' },
        { title: 'Enter the Portal', description: 'Particles flow into a digital interface', icon: 'globe' },
        { title: 'Continue the Conversation', description: 'Mobile interface with cycling prompts', icon: 'chevron-right' },
        { title: 'Become Part of the Archive', description: 'Nodes connecting across a map or network', icon: 'archive' },
    ];

    let activeStep = 0;
    let isAutoPlaying = true;
    let autoPlayInterval;

    const renderStep = (index) => {
        const step = steps[index];
        display.innerHTML = `
            <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-4 transition-all duration-500">
                <div class="w-32 h-32 mb-[32px] rounded-[9999px] bg-gradient-to-br from-purple-500/20 to-yellow-500/20 border-2 border-white/20 flex items-center justify-center portal-icon-glow">
                    <i data-lucide="${step.icon}" class="w-[32px] h-[32px] text-white"></i>
                </div>
                <h3 class="text-[30px] md:text-[48px] font-garamond text-white mb-[16px]">${step.title}</h3>
                <p class="text-[18px] md:text-[20px] text-gray-300 max-w-[672px]">${step.description}</p>
            </div>
        `;
        if (typeof lucide !== 'undefined') lucide.createIcons({ root: display });

        // Update dots
        dots.forEach((dot, i) => {
            dot.className = `artifact-portal-dot h-[12px] rounded-[9999px] transition-all ${i === index ? 'bg-yellow-400 w-[48px]' : 'bg-white/30 w-[12px] hover:bg-white/50'}`;
        });

        // Update labels
        labels.forEach((label, i) => {
            if (i === index) {
                label.className = 'artifact-portal-label flex-1 text-center text-[14px] font-medium text-yellow-400 opacity-100 transition-all';
            } else {
                label.className = 'artifact-portal-label flex-1 text-center text-[14px] font-medium text-gray-500 opacity-60 hover:opacity-80 transition-all';
            }
        });
    };

    const goToStep = (index) => {
        activeStep = index;
        renderStep(activeStep);
    };

    const startAutoPlay = () => {
        if (!isAutoPlaying || autoPlayInterval) return;
        autoPlayInterval = setInterval(() => {
            activeStep = (activeStep + 1) % steps.length;
            renderStep(activeStep);
        }, 4000);
    };

    const stopAutoPlay = () => {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
    };

    // Attach dot click handlers
    dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
            isAutoPlaying = false;
            stopAutoPlay();
            goToStep(i);
        });
    });

    // Attach label click handlers
    labels.forEach((label, i) => {
        label.addEventListener('click', () => {
            isAutoPlaying = false;
            stopAutoPlay();
            goToStep(i);
        });
    });

    // Floating particles
    const particleContainer = document.getElementById('portal-particles');
    if (particleContainer) {
        for (let i = 0; i < 20; i++) {
            const p = document.createElement('div');
            p.className = 'absolute w-1 h-1 bg-white/30 rounded-[9999px]';
            p.style.left = `${Math.random() * 100}%`;
            p.style.top = `${Math.random() * 100}%`;
            const dur = (Math.random() * 10 + 10).toFixed(1);
            p.style.animation = `particleFloat ${dur}s linear infinite`;
            particleContainer.appendChild(p);
        }
    }

    renderStep(0);
    startAutoPlay();

    display._startAutoplay = startAutoPlay;
    display._stopAutoplay = stopAutoPlay;
};


const initInteractions = () => {
    // Navigation Toggle
    const navToggle = document.getElementById('nav-toggle');
    const navMenu = document.getElementById('nav-menu');
    const menuIcon = document.getElementById('menu-icon');
    const closeIcon = document.getElementById('close-icon');

    if (navToggle) {
        navToggle.addEventListener('click', () => {
            navMenu.classList.toggle('hidden');
            menuIcon.classList.toggle('hidden');
            closeIcon.classList.toggle('hidden');
        });
    }

    // Sticky Nav Logic with Scroll Spy
    const stickyNav = document.getElementById('sticky-nav');
    const navButtons = document.querySelectorAll('.nav-btn');

    const sections = [
        { id: 'experience-selector', path: 'attend' },
        { id: 'what-happens', path: 'attend' },
        { id: 'questions', path: 'attend' },
        { id: 'token-economy', path: 'attend' },
        { id: 'host-section', path: 'host' },
        { id: 'vendor-economy', path: 'vendor' },
        { id: 'partnership', path: 'sponsor' },
    ];

    let lastActivePath = 'attend';
    let sectionPositions = [];

    const cacheSectionPositions = () => {
        sectionPositions = sections.map(section => {
            const element = document.getElementById(section.id);
            if (element) {
                const rect = element.getBoundingClientRect();
                const top = rect.top + window.scrollY;
                return {
                    id: section.id,
                    path: section.path,
                    top: top,
                    bottom: top + element.offsetHeight
                };
            }
            return null;
        }).filter(Boolean);
    };

    // Cache once initially, and update on resize
    setTimeout(cacheSectionPositions, 1000);
    window.addEventListener('resize', cacheSectionPositions);

    const updateActiveSection = () => {
        const screenTop = window.scrollY;
        const screenBottom = screenTop + window.innerHeight;

        let currentPath = null;
        let maxVisibleHeight = 0;

        for (const section of sectionPositions) {
            // Calculate visible overlap
            const visibleTop = Math.max(screenTop, section.top);
            const visibleBottom = Math.min(screenBottom, section.bottom);

            if (visibleBottom > visibleTop) {
                const visibleHeight = visibleBottom - visibleTop;
                if (visibleHeight > maxVisibleHeight) {
                    maxVisibleHeight = visibleHeight;
                    currentPath = section.path;
                }
            }
        }

        // Keep last active if no tracked section is on screen
        if (currentPath) {
            lastActivePath = currentPath;
        } else {
            currentPath = lastActivePath;
        }

        navButtons.forEach(btn => {
            const path = btn.dataset.path;
            const isActive = path === currentPath;

            if (isActive) {
                btn.classList.add('bg-gradient-to-r', 'from-red-500', 'to-orange-500', 'text-white', 'shadow-lg');
                btn.classList.remove('bg-white/5', 'text-gray-300');
            } else {
                btn.classList.remove('bg-gradient-to-r', 'from-red-500', 'to-orange-500', 'text-white', 'shadow-lg');
                btn.classList.add('bg-white/5', 'text-gray-300');
            }
        });
    };

    if (stickyNav) {
        let ticking = false;
        window.addEventListener('scroll', () => {
            if (window.scrollY > 600) {
                stickyNav.classList.add('show');
            } else {
                stickyNav.classList.remove('show');
            }

            if (!ticking) {
                window.requestAnimationFrame(() => {
                    updateActiveSection();
                    ticking = false;
                });
                ticking = true;
            }
        }, { passive: true });
        
        // Initial cache and run
        cacheSectionPositions();
        updateActiveSection();
    }

    // Floating puzzle pieces background
    const initPuzzleBackground = () => {
        const puzzleBg = document.getElementById('puzzle-bg');
        if (!puzzleBg) return;

        // Fallback for mobile/tablet screens to prevent GPU/CPU memory OOM crashes
        const isMobile = window.innerWidth < 1024 || /Mobi|Android|iPhone|iPad|Macintosh/i.test(navigator.userAgent) && ('ontouchstart' in window);
        if (isMobile) return; // Do not render floating background pieces on mobile devices

        for (let i = 0; i < 6; i++) {
            const piece = document.createElement('div');
            piece.className = 'absolute w-64 h-64 border-2 border-white/10 rounded-[24px] pointer-events-none';
            piece.style.left = Math.random() * 100 + '%';
            piece.style.top = Math.random() * 100 + '%';

            const startRotation = Math.random() * 360;
            piece.style.transform = `rotate(${startRotation}deg)`;

            piece.animate([
                { transform: `rotate(${startRotation}deg) translate(0, 0)`, opacity: 0.05 },
                { transform: `rotate(${startRotation + 20}deg) translate(${Math.random() * 50 - 25}px, ${Math.random() * 50 - 25}px)`, opacity: 0.08 },
                { transform: `rotate(${startRotation}deg) translate(0, 0)`, opacity: 0.05 }
            ], {
                duration: 15000 + Math.random() * 10000,
                iterations: Infinity,
                easing: 'ease-in-out'
            });

            puzzleBg.appendChild(piece);
        }
    };
    initPuzzleBackground();
    // System Map Interaction & State
    const systemState = {
        exploredNodes: new Set(),
        puzzleAssembled: false,
        experienceLayers: 1,
        tokenSimulation: { count: 0, showOptions: false },
        tokenFlowing: false
    };

    const renderSkeletonLoader = () => {
        return `
            <div class="flex flex-col items-center justify-center gap-[16px] py-[48px] w-full animate-pulse">
                <div class="w-[48px] h-[48px] rounded-full border-[4px] border-white/10 border-t-white/60 animate-spin"></div>
                <span class="text-gray-400 text-[14px]">Loading interaction...</span>
            </div>
        `;
    };

    window.openSystemModal = (nodeId) => {
        const modal = document.getElementById('system-modal');
        const content = document.getElementById('system-modal-content');
        const inner = document.getElementById('modal-inner-content');

        if (!modal || !inner) return;

        // Visual feedback on the map
        const group = document.querySelector(`[data-node-id="${nodeId}"]`);
        if (group) {
            const circle = group.querySelector('.node-circle');
            const isMobileViewport = window.innerWidth < 1024 || /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent) || ('ontouchstart' in window);
            
            if (circle && !isMobileViewport) {
                // Add celebration ring (skip on mobile to prevent WebKit rendering OOM crashes)
                const ring = document.createElementNS("http://www.w3.org/2000/svg", "circle");
                ring.setAttribute("cx", circle.getAttribute("cx"));
                ring.setAttribute("cy", circle.getAttribute("cy"));
                ring.setAttribute("r", circle.getAttribute("r"));
                ring.setAttribute("fill", "none");
                ring.setAttribute("stroke", circle.getAttribute("stroke") || "#facc15");
                ring.setAttribute("stroke-width", "2");
                ring.setAttribute("class", "celebration-ring");
                group.appendChild(ring);
                setTimeout(() => ring.remove(), 600);
            }
            group.classList.add('explored', 'active');
            const check = group.querySelector('.node-check');
            if (check) check.classList.remove('hidden');
        }

        // De-activate other nodes visually
        document.querySelectorAll('.system-node-group').forEach(el => {
            if (el.getAttribute('data-node-id') !== nodeId) el.classList.remove('active');
        });

        // Track exploration
        systemState.exploredNodes.add(nodeId);
        if (typeof updateMapProgress === 'function') updateMapProgress();

        // Render skeleton template structure immediately
        inner.innerHTML = renderSystemModalContent(nodeId);

        // Show modal instantly
        modal.classList.remove('hidden');
        modal.classList.add('flex');
        
        // Force reflow
        void modal.offsetWidth;

        content.classList.remove('scale-95', 'opacity-0');
        content.classList.add('scale-100', 'opacity-100');

        document.body.style.overflow = 'hidden';

        // Initialize visible initial icons quickly (scoped to the newly loaded modal element)
        if (typeof lucide !== 'undefined') {
            lucide.createIcons({ root: inner });
        }

        // Defer heavier dynamic interactions for 300ms to bypass entry animation style-calculation spikes
        setTimeout(() => {
            hydrateModalInteractions(nodeId, inner);
        }, 300);
    };

    const hydrateModalInteractions = (nodeId, rootNode) => {
        if (nodeId === 'exhibition') {
            const container = rootNode.querySelector('#puzzle-interaction-container');
            if (container) {
                container.innerHTML = renderPuzzleInteraction();
                if (typeof lucide !== 'undefined') lucide.createIcons({ root: container });
            }
        } else if (nodeId === 'live-experience') {
            const container = rootNode.querySelector('#music-interaction-container');
            if (container) {
                container.innerHTML = renderMusicInteraction();
                if (typeof lucide !== 'undefined') lucide.createIcons({ root: container });
            }
        } else if (nodeId === 'tokens') {
            const container1 = rootNode.querySelector('#token-interaction-container');
            if (container1) {
                container1.innerHTML = window.renderTokenInteraction();
                if (typeof lucide !== 'undefined') lucide.createIcons({ root: container1 });
            }
            const container2 = rootNode.querySelector('#token-flow-container');
            if (container2) {
                container2.innerHTML = window.renderTokenFlowAnimation();
                if (typeof lucide !== 'undefined') lucide.createIcons({ root: container2 });
            }
        } else if (nodeId === 'vibelink') {
            const container = rootNode.querySelector('#vibelink-interaction-container');
            if (container) {
                container.innerHTML = renderVibeLinkInteraction();
                if (typeof lucide !== 'undefined') lucide.createIcons({ root: container });
            }
        } else if (nodeId === 'beyond-the-room') {
            const container = rootNode.querySelector('#beyond-interaction-container');
            if (container) {
                container.innerHTML = renderBeyondInteraction();
                if (typeof lucide !== 'undefined') lucide.createIcons({ root: container });
            }
        }
    };

    window.closeSystemModal = () => {
        const modal = document.getElementById('system-modal');
        const content = document.getElementById('system-modal-content');
        const inner = document.getElementById('modal-inner-content');
        if (!modal || !content) return;

        // Immediately purge resources to prevent iOS Safari memory footprint from remaining bloated
        if (inner) {
            inner.querySelectorAll('img, video, iframe').forEach(el => {
                el.src = '';
                el.removeAttribute('src');
                if (typeof el.load === 'function') el.load();
            });
        }

        content.classList.remove('scale-100', 'opacity-100');
        content.classList.add('scale-95', 'opacity-0');

        setTimeout(() => {
            modal.classList.add('hidden');
            document.body.style.overflow = '';
            if (inner) inner.innerHTML = ''; // FREE UP MEMORY! Remove GIFs and active media
        }, 500);
    };

    const updateMapProgress = () => {
        const count = systemState.exploredNodes.size;
        const remaining = 6 - count;

        // Update instruction text
        const initial = document.getElementById('instruction-initial');
        const progress = document.getElementById('instruction-progress');
        const complete = document.getElementById('instruction-complete');
        const remainingCount = document.getElementById('remaining-count');

        if (count === 0) {
            if (initial) initial.classList.remove('hidden');
            if (progress) progress.classList.add('hidden');
            if (complete) complete.classList.add('hidden');
        } else if (count < 6) {
            if (initial) initial.classList.add('hidden');
            if (progress) progress.classList.remove('hidden');
            if (complete) complete.classList.add('hidden');
            if (remainingCount) remainingCount.innerText = remaining;
        } else {
            if (initial) initial.classList.add('hidden');
            if (progress) progress.classList.add('hidden');
            if (complete) complete.classList.remove('hidden');
            if (complete) complete.classList.add('flex');
        }

        // Update dots
        document.querySelectorAll('[data-dot]').forEach((dot, idx) => {
            if (idx < count) {
                dot.classList.remove('bg-gray-600');
                dot.classList.add('bg-yellow-400', 'shadow-lg', 'shadow-yellow-400/50', 'animate-pulse');
            }
        });

        // Show dots container
        const dotsContainer = document.getElementById('map-progress-dots');
        if (dotsContainer && count > 0) {
            dotsContainer.classList.remove('opacity-0');
            dotsContainer.classList.add('opacity-100');
        }

        // Update node visual state (stop blinking)
        systemState.exploredNodes.forEach(id => {
            const group = document.querySelector(`[data-node-id="${id}"]`);
            if (group) {
                const circle = group.querySelector('.node-circle');
                const line = document.getElementById(`line-${id}`);
                const check = group.querySelector('.node-check');

                if (circle) circle.classList.remove('animate-pulse');
                if (line) {
                    line.style.strokeOpacity = '0.8';
                    line.classList.add('active-line');
                }
                if (check) check.classList.remove('hidden');
            }
        });
    };

    const renderVibeLinkInteraction = () => {
        return `
            <div class="relative w-full h-[384px] flex flex-col items-center justify-center gap-[24px]">
                <!-- Floating Activity Labels -->
                <div class="grid grid-cols-2 gap-[16px] mb-[16px]">
                    <div class="bg-purple-500/20 border border-purple-500/40 rounded-[8px] px-[16px] py-[12px] backdrop-blur-sm animate-scaleIn">
                        <div class="text-[24px] font-garamond text-purple-300 mb-[4px]">12 playing now</div>
                        <div class="text-[12px] text-gray-400">Active participants</div>
                    </div>

                    <div class="bg-purple-500/20 border border-purple-500/40 rounded-[8px] px-[16px] py-[12px] backdrop-blur-sm animate-scaleIn" style="animation-delay: 0.2s">
                        <div class="text-[24px] font-garamond text-purple-300 mb-[4px]">5 open to connect</div>
                        <div class="text-[12px] text-gray-400">Available for interaction</div>
                    </div>
                </div>

                <!-- Pulsing Avatars with Connection Lines -->
                <div class="relative w-full h-[192px]">
                    <!-- Connection lines -->
                    <svg class="absolute inset-0 w-full h-full">
                        <line x1="20%" y1="50%" x2="40%" y2="30%" stroke="rgba(168, 85, 247, 0.4)" stroke-width="2" stroke-dasharray="5,5" />
                        <line x1="40%" y1="30%" x2="60%" y2="50%" stroke="rgba(168, 85, 247, 0.4)" stroke-width="2" stroke-dasharray="5,5" />
                        <line x1="60%" y1="50%" x2="80%" y2="40%" stroke="rgba(168, 85, 247, 0.4)" stroke-width="2" stroke-dasharray="5,5" />
                    </svg>

                    <!-- Pulsing avatars -->
                    <div class="absolute w-[48px] h-[48px] md:w-[56px] md:h-[56px] rounded-[9999px] border-[2px] border-purple-500 bg-purple-500/30 backdrop-blur-sm flex items-center justify-center shadow-lg animate-scaleIn" style="left: 20%; top: 50%; transform: translate(-50%, -50%);">
                        <i data-lucide="users" class="w-[24px] h-[24px] text-purple-300"></i>
                        <div class="absolute inset-0 rounded-[9999px] border-[2px] border-purple-400 animate-ping opacity-30"></div>
                    </div>
                    <div class="absolute w-[48px] h-[48px] md:w-[56px] md:h-[56px] rounded-[9999px] border-[2px] border-purple-500 bg-purple-500/30 backdrop-blur-sm flex items-center justify-center shadow-lg animate-scaleIn" style="left: 40%; top: 30%; transform: translate(-50%, -50%); animation-delay: 0.2s">
                        <i data-lucide="users" class="w-[24px] h-[24px] text-purple-300"></i>
                        <div class="absolute inset-0 rounded-[9999px] border-[2px] border-purple-400 animate-ping opacity-30"></div>
                    </div>
                    <div class="absolute w-[48px] h-[48px] md:w-[56px] md:h-[56px] rounded-[9999px] border-[2px] border-purple-500 bg-purple-500/30 backdrop-blur-sm flex items-center justify-center shadow-lg animate-scaleIn" style="left: 60%; top: 50%; transform: translate(-50%, -50%); animation-delay: 0.4s">
                        <i data-lucide="users" class="w-[24px] h-[24px] text-purple-300"></i>
                        <div class="absolute inset-0 rounded-[9999px] border-[2px] border-purple-400 animate-ping opacity-30"></div>
                    </div>
                    <div class="absolute w-[48px] h-[48px] md:w-[56px] md:h-[56px] rounded-[9999px] border-[2px] border-purple-500 bg-purple-500/30 backdrop-blur-sm flex items-center justify-center shadow-lg animate-scaleIn" style="left: 80%; top: 40%; transform: translate(-50%, -50%); animation-delay: 0.6s">
                        <i data-lucide="users" class="w-[24px] h-[24px] text-purple-300"></i>
                        <div class="absolute inset-0 rounded-[9999px] border-[2px] border-purple-400 animate-ping opacity-30"></div>
                    </div>
                </div>

                <p class="absolute -bottom-[24px] text-[12px] text-gray-500 italic">
                    The room becomes part of the experience.
                </p>
            </div>
        `;
    };

    const renderBeyondInteraction = () => {
        return `
            <div class="relative w-full h-full flex items-center justify-center">
                <!-- Portal visualization with floating data points -->
                <div class="relative w-[256px] h-[256px] md:w-[320px] md:h-[320px]">
                    <!-- Central portal -->
                    <div class="absolute inset-0 rounded-[9999px] bg-gradient-to-br from-pink-500/30 via-purple-500/30 to-pink-500/30 border-2 border-pink-500/50 animate-spin-slow animate-pulse"></div>

                    <!-- Inner glow -->
                    <div class="absolute inset-8 rounded-[9999px] bg-gradient-to-br from-pink-400/40 via-purple-400/40 to-pink-400/40 blur-xl animate-pulse" style="animation-duration: 4s"></div>

                    <!-- Floating data points -->
                    ${[...Array(12)].map((_, i) => {
                        const angle = (i * 30) * (Math.PI / 180);
                        const tx = Math.cos(angle) * 180;
                        const ty = Math.sin(angle) * 180;
                        return `
                            <div class="absolute w-2 h-2 md:w-[12px] md:h-[12px] bg-pink-400 rounded-[9999px] shadow-lg"
                                 style="left: 50%; top: 50%; transform: translate(-50%, -50%); 
                                        animation: dataPointFlow 6s infinite ease-out;
                                        animation-delay: ${i * 0.5}s;
                                        --tx: ${tx}px; --ty: ${ty}px;">
                            </div>
                        `;
                    }).join('')}

                    <!-- Center icon -->
                    <div class="absolute inset-0 flex items-center justify-center">
                        <div class="w-[64px] h-[64px] md:w-20 md:h-20 rounded-[9999px] bg-pink-500/20 border border-pink-500/40 flex items-center justify-center backdrop-blur-sm shadow-2xl animate-bounce-slow">
                            <i data-lucide="globe" class="w-[32px] h-[32px] md:w-10 md:h-10 text-pink-400"></i>
                        </div>
                    </div>
                </div>

                <p class="absolute -bottom-6 text-[12px] text-gray-500 italic">
                    Your voice lives on in the digital archive.
                </p>
            </div>
        `;
    };

    const renderSystemModalContent = (nodeId) => {
        // Content based on React App.tsx logic
        if (nodeId === 'exhibition') {
            return `
                <div class="w-full grid md:grid-cols-2 md:min-h-[600px]">
                    <div class="p-[24px] md:p-[48px] flex flex-col justify-center">
                        <!-- Media Embed Area -->
                        <div class="relative w-full aspect-video rounded-[12px] overflow-hidden mb-[24px] shadow-2xl">
                            <img src="https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Step_3__also_include_in_the_build_mural_node_media_upload.gif?v=1778826678" alt="Building the mural" class="w-full h-full object-cover">
                        </div>
                        <i data-lucide="puzzle" class="w-[48px] h-[48px] md:w-[64px] md:h-[64px] mb-[16px] md:mb-[24px] text-red-500"></i>
                        <h3 class="font-garamond text-[30px] md:text-[48px] mb-[16px] md:mb-[24px] text-white">Build the Mural</h3>
                        <p class="text-[16px] md:text-[20px] text-gray-300 mb-[24px] md:mb-[32px] leading-relaxed">
                            Add puzzle pieces through participation and collective action. Watch the full picture come together in real time.
                        </p>
                        <h4 class="text-[18px] md:text-[20px] mb-[16px] font-garamond text-white">What you do:</h4>
                        <ul class="space-y-[12px] md:space-y-[16px] mb-[24px] md:mb-[32px]">
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-red-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Contribute through prompts and interactive installations</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-red-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">See your piece become part of the larger artwork</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-red-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Watch the collective picture emerge</span>
                            </li>
                        </ul>
                        <div class="bg-red-500/10 border border-red-500/30 rounded-[8px] p-[16px] mb-[24px] md:mb-[32px]">
                            <p class="text-[12px] md:text-[14px] text-gray-300 italic">
                                Each piece continues beyond the exhibition through the Artifact Portal
                            </p>
                        </div>
                        <a href="https://vibesandvirtues.com/pages/landing#puzzle-artworks" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-[8px] px-[24px] py-[12px] bg-red-500 hover:bg-red-600 text-white rounded-[8px] transition-all shadow-lg group w-fit">
                            <i data-lucide="puzzle" class="w-[20px] h-[20px]"></i>
                            <span>Explore the Puzzle Artworks</span>
                            <i data-lucide="chevron-right" class="w-[20px] h-[20px] group-hover:translate-x-[4px] transition-transform"></i>
                        </a>
                    </div>
                    <div class="bg-gradient-to-br from-white/5 to-transparent p-[24px] md:p-[48px] flex flex-col gap-[24px] md:border-l border-white/10 min-h-[400px] rounded-r-[16px]">
                        <div class="flex-1 flex items-center justify-center relative" id="puzzle-interaction-container">
                            ${renderSkeletonLoader()}
                        </div>
                    </div>
                </div>
            `;
        }

        if (nodeId === 'live-experience') {
            return `
                <div class="w-full grid md:grid-cols-2 md:min-h-[600px]">
                    <div class="p-[24px] md:p-[48px] flex flex-col justify-center">
                        <div class="relative w-full aspect-video rounded-[12px] overflow-hidden mb-[32px] shadow-2xl">
                            <img src="https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Step_5__also_include_in_the_live_music_integration_media_upload_node.gif?v=1778826824" alt="Live Music" class="w-full h-full object-cover">
                        </div>
                        <i data-lucide="mic-2" class="w-[48px] h-[48px] md:w-[64px] md:h-[64px] mb-[16px] md:mb-[24px] text-blue-500"></i>
                        <h3 class="font-garamond text-[36px] md:text-[48px] mb-[16px] md:mb-[24px] text-white">Live Music Integration</h3>
                        <p class="text-[16px] md:text-[20px] text-gray-300 mb-[24px] md:mb-[32px] leading-relaxed">
                            In select formats, live music is woven into the experience—emerging from the themes in real time.
                        </p>
                        <div class="inline-flex items-center gap-[8px] px-[12px] py-[4px] bg-blue-500/20 border border-blue-500/30 rounded-[9999px] text-[12px] text-blue-300 mb-[24px] w-fit">
                            Available when space and format allow
                        </div>
                        
                        <div class="mb-[24px]">
                            <h4 class="text-[18px] md:text-[20px] mb-[16px] font-garamond text-white">What happens:</h4>
                            <ul class="space-y-[12px] md:space-y-[16px] mb-[24px]">
                                <li class="flex items-start gap-[12px]">
                                    <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-blue-400 flex-shrink-0 mt-[4px]"></i>
                                    <span class="text-gray-300 text-[14px] md:text-[16px]">Music is tied to each puzzle theme</span>
                                </li>
                                <li class="flex items-start gap-[12px]">
                                    <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-blue-400 flex-shrink-0 mt-[4px]"></i>
                                    <span class="text-gray-300 text-[14px] md:text-[16px]">Performances evolve as the mural builds</span>
                                </li>
                                <li class="flex items-start gap-[12px]">
                                    <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-blue-400 flex-shrink-0 mt-[4px]"></i>
                                    <span class="text-gray-300 text-[14px] md:text-[16px]">The audience becomes part of the moment</span>
                                </li>
                            </ul>
                        </div>
                        
                        <div class="bg-blue-500/10 border border-blue-500/30 rounded-[8px] p-[16px] mb-[24px] md:mb-[32px]">
                            <h4 class="text-[14px] md:text-[16px] font-garamond mb-[8px] text-blue-400">Integration depends on:</h4>
                            <p class="text-[12px] md:text-[14px] text-gray-300 leading-relaxed">Venue capabilities, format type, and experience goals. When integrated, music transforms the experience—turning reflection into something you can feel.</p>
                        </div>

                        <a href="https://vibesandvirtues.com/pages/about-carey-music" target="_blank" class="inline-flex items-center gap-[8px] px-[24px] py-[12px] bg-blue-500 hover:bg-blue-600 text-white rounded-[8px] transition-all shadow-lg group w-fit">
                            <i data-lucide="mic-2" class="w-[20px] h-[20px]"></i>
                            <span>Explore the Music</span>
                            <i data-lucide="chevron-right" class="w-[20px] h-[20px] group-hover:translate-x-[4px] transition-transform"></i>
                        </a>
                    </div>
                    <div class="bg-gradient-to-br from-white/5 to-transparent p-[24px] md:p-[48px] flex flex-col gap-[24px] md:border-l border-white/10 min-h-[400px] rounded-r-[16px]">
                        <div class="flex-1 flex flex-col items-center justify-center gap-[48px]" id="music-interaction-container">
                            ${renderSkeletonLoader()}
                        </div>
                    </div>
                </div>
            `;
        }

        if (nodeId === 'card-game') {
            return `
                <div class="w-full grid md:grid-cols-2 md:min-h-[600px]">
                    <div class="p-[24px] md:p-[48px] flex flex-col justify-center">
                        <!-- Media Embed Area -->
                        <div class="relative w-full aspect-video rounded-[12px] overflow-hidden mb-[24px] shadow-2xl">
                            <img src="https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Step_4_use__also_include_in_the_play_the_card_game_node_media_upload.gif?v=1778826754" alt="Playing the card game" class="w-full h-full object-cover">
                        </div>
                        <i data-lucide="layers" class="w-[48px] h-[48px] md:w-[64px] md:h-[64px] mb-[16px] md:mb-[24px] text-orange-500"></i>
                        <h3 class="font-garamond text-[30px] md:text-[48px] mb-[16px] md:mb-[24px] text-white">Play the Card Game</h3>
                        <p class="text-[16px] md:text-[20px] text-gray-300 mb-[24px] md:mb-[32px] leading-relaxed">
                            Sit down, read the room, and test your intuition. This isn't just conversation—it's strategy.
                        </p>
                        <h4 class="text-[18px] md:text-[20px] mb-[16px] font-garamond text-white">How it works:</h4>
                        <ul class="space-y-[12px] md:space-y-[16px] mb-[24px]">
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="chevron-right" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-orange-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Lead player asks a Question Card from their hand</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="chevron-right" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-orange-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Everyone answers YES or NO secretly (face down)</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="chevron-right" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-orange-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Lead player guesses each person's answer</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="chevron-right" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-orange-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Reveal cards — correct guesses stay face up</span>
                            </li>
                        </ul>

                        <h4 class="text-[18px] md:text-[20px] mb-[16px] font-garamond text-white">How you win:</h4>
                        <ul class="space-y-[12px] md:space-y-[16px] mb-[24px]">
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-orange-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Guess enough correctly (varies by group size) → discard a card</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-orange-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Guess wrong → draw a card from the pile</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-orange-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">First to discard all cards (except YES/NO) wins</span>
                            </li>
                        </ul>

                        <div class="bg-orange-500/10 border border-orange-500/30 rounded-[8px] p-[16px] mb-[24px] md:mb-[32px]">
                            <h4 class="text-[14px] md:text-[16px] font-garamond mb-[8px] text-orange-400">Optional token wagering at Wildcard:</h4>
                            <p class="text-[12px] md:text-[14px] text-gray-300 mb-[8px] leading-relaxed">Players can bet Vibe Tokens when placing their YES/NO card. Lead player can match the bet before guessing.</p>
                            <p class="text-[12px] md:text-[14px] text-gray-400 italic">Guess correctly? Keep all tokens. Guess wrong? Other player takes all.</p>
                        </div>

                        <a href="https://vibesandvirtues.com/collections/card-game-decks" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-[8px] px-[24px] py-[12px] bg-orange-500 hover:bg-orange-600 text-white rounded-[8px] transition-all shadow-lg group w-fit">
                            <i data-lucide="layers" class="w-[20px] h-[20px]"></i>
                            <span>Explore the Card Game</span>
                            <i data-lucide="chevron-right" class="w-[20px] h-[20px] group-hover:translate-x-[4px] transition-transform"></i>
                        </a>
                    </div>
                    <div class="bg-gradient-to-br from-white/5 to-transparent p-[24px] md:p-[48px] flex flex-col gap-[24px] md:border-l border-white/10 min-h-[400px] rounded-r-[16px]">
                        <div class="flex-1 flex flex-col items-center justify-center gap-[32px] relative">
                            <div class="grid grid-cols-3 gap-[16px]">
                                ${['V', '&', 'V', 'YES', 'NO'].map((label, i) => `
                                    <div class="w-[64px] h-[96px] md:w-[80px] md:h-[112px] rounded-[12px] border-[2px] border-orange-500 bg-gradient-to-br from-orange-500/20 to-orange-600/20 flex items-center justify-center shadow-2xl relative overflow-hidden backdrop-blur-sm animate-scaleIn"
                                         style="animation-delay: ${i * 0.15}s">
                                        <div class="absolute inset-0 bg-gradient-to-br from-orange-400/10 to-transparent pointer-events-none"></div>
                                        <span class="text-[20px] md:text-[24px] font-garamond text-white z-10">${label}</span>
                                    </div>
                                `).join('')}
                            </div>
                            <p class="absolute bottom-0 text-[14px] text-gray-400">Read the room. Win the game.</p>
                        </div>
                    </div>
                </div>
            `;
        }

        if (nodeId === 'tokens') {
            return `
                <div class="w-full grid md:grid-cols-2 md:min-h-[600px]">
                    <div class="p-[24px] md:p-[48px] flex flex-col justify-center">
                        <div class="relative w-full aspect-video rounded-[12px] overflow-hidden mb-[24px] shadow-2xl">
                            <img src="https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Step_6__also_include_in_the_vibe_tokens_media_upload_node.gif?v=1778826897" alt="Vibe Tokens" class="w-full h-full object-cover">
                        </div>

                        <!-- Economy Flow Visual -->
                        <div class="relative w-full bg-gradient-to-br from-green-500/10 to-emerald-500/5 rounded-[12px] border border-green-500/20 overflow-hidden mb-[24px] p-[16px] md:p-[24px]">
                            <div class="flex flex-wrap md:flex-nowrap items-center justify-center md:justify-between gap-[8px] md:gap-[16px]">
                                <div class="flex-1 min-w-[60px] text-center">
                                    <div class="w-[40px] h-[40px] md:w-[48px] md:h-[48px] mx-auto mb-[4px] md:mb-[8px] rounded-[8px] bg-yellow-500/20 border border-yellow-500/40 flex items-center justify-center animate-pulse">
                                        <i data-lucide="edit-3" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-yellow-400"></i>
                                    </div>
                                    <p class="text-[10px] md:text-[12px] text-gray-300">Participate</p>
                                </div>
                                <i data-lucide="chevron-right" class="w-[16px] h-[16px] md:w-[20px] md:h-[20px] text-green-400 flex-shrink-0"></i>
                                <div class="flex-1 min-w-[60px] text-center">
                                    <div class="w-[40px] h-[40px] md:w-[48px] md:h-[48px] mx-auto mb-[4px] md:mb-[8px] rounded-[8px] bg-green-500/20 border border-green-500/40 flex items-center justify-center animate-pulse">
                                        <i data-lucide="coins" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-green-400"></i>
                                    </div>
                                    <p class="text-[10px] md:text-[12px] text-gray-300">Earn</p>
                                </div>
                                <i data-lucide="chevron-right" class="w-[16px] h-[16px] md:w-[20px] md:h-[20px] text-green-400 flex-shrink-0"></i>
                                <div class="flex-1 min-w-[60px] text-center">
                                    <div class="w-[40px] h-[40px] md:w-[48px] md:h-[48px] mx-auto mb-[4px] md:mb-[8px] rounded-[8px] bg-blue-500/20 border border-blue-500/40 flex items-center justify-center animate-pulse">
                                        <i data-lucide="shopping-bag" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-blue-400"></i>
                                    </div>
                                    <p class="text-[10px] md:text-[12px] text-gray-300">Redeem</p>
                                </div>
                                <i data-lucide="chevron-right" class="w-[16px] h-[16px] md:w-[20px] md:h-[20px] text-green-400 flex-shrink-0"></i>
                                <div class="flex-1 min-w-[60px] text-center">
                                    <div class="w-[40px] h-[40px] md:w-[48px] md:h-[48px] mx-auto mb-[4px] md:mb-[8px] rounded-[8px] bg-purple-500/20 border border-purple-500/40 flex items-center justify-center">
                                        <i data-lucide="refresh-cw" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-purple-400 animate-spin-slow"></i>
                                    </div>
                                    <p class="text-[10px] md:text-[12px] text-gray-300">Circulate</p>
                                </div>
                            </div>
                        </div>

                        <i data-lucide="coins" class="w-[48px] h-[48px] md:w-[64px] md:h-[64px] mb-[16px] md:mb-[24px] text-green-500"></i>
                        <h3 class="font-garamond text-[30px] md:text-[48px] mb-[16px] md:mb-[24px] text-white">Your Voice Has Value Here</h3>
                        <p class="text-[16px] md:text-[20px] text-gray-300 mb-[24px] md:mb-[32px] leading-relaxed">
                            Earn Vibe Tokens through participation—and use them for real things.
                        </p>
                        <div class="bg-gradient-to-r from-green-500/20 via-blue-500/20 to-purple-500/20 border border-green-500/30 rounded-[8px] p-[20px] mb-[24px]">
                            <p class="text-[14px] md:text-[16px] text-gray-200 leading-relaxed">
                                <strong class="text-green-300">Drinks. Merchandise. Local products. Artist goods.</strong><br/>
                                If it's part of the space, tokens can unlock it.
                            </p>
                        </div>
                        <h4 class="text-[18px] md:text-[20px] mb-[16px] font-garamond text-white">How you earn:</h4>
                        <ul class="space-y-[12px] md:space-y-[16px] mb-[24px]">
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-green-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Answering prompts, contributing to the mural</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-green-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Engaging in conversation and connection</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-green-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Playing the card game, sharing your story</span>
                            </li>
                        </ul>
                        <div class="bg-green-500/10 border border-green-500/30 rounded-[8px] p-[16px] mb-[24px]">
                            <p class="text-[12px] md:text-[14px] text-gray-300 italic">
                                Earn and redeem beyond the event through the Portal
                            </p>
                        </div>
                            <!-- Interactive Token Simulation (Try It Out) moved to bottom of left column -->
                        <div id="token-interaction-container" class="mt-[24px] flex justify-center w-full">
                            ${renderSkeletonLoader()}
                        </div>
                    </div>
                    <div class="bg-gradient-to-br from-white/5 to-transparent p-[24px] md:p-[48px] flex flex-col gap-[24px] md:border-l border-white/10 min-h-[400px] rounded-r-[16px]">
                      
                        <div class="flex-1 flex flex-col items-center justify-center gap-[32px]" id="token-flow-container">
                            ${renderSkeletonLoader()}
                        </div>
                    </div>
                </div>
            `;
        }

        if (nodeId === 'vibelink') {
            return `
                <div class="w-full grid md:grid-cols-2 md:min-h-[600px]">
                    <div class="p-[24px] md:p-[48px] flex flex-col justify-center">
                        <!-- Media Embed Area -->
                        <div class="relative w-full aspect-video rounded-[12px] overflow-hidden mb-[24px] shadow-2xl">
                            <img src="https://cdn.shopify.com/s/files/1/0328/9032/3077/files/VibeLink.gif?v=1778826979" alt="VibeLink network in action" class="w-full h-full object-cover">
                        </div>
                        <div class="mb-[16px]">
                            <span class="text-[12px] text-purple-400 uppercase tracking-wider">Separate Venue Service</span>
                            <div class="inline-block ml-[12px] px-[8px] py-[4px] bg-purple-500/20 border border-purple-500/40 rounded-[4px] text-[10px] text-purple-300">
                                NOT Part of Wildcard Events
                            </div>
                        </div>
                        <i data-lucide="map-pin" class="w-[48px] h-[48px] md:w-[64px] md:h-[64px] mb-[16px] md:mb-[24px] text-purple-500"></i>
                        <h3 class="font-garamond text-[30px] md:text-[48px] mb-[16px] md:mb-[24px] text-white">VibeLink: Ongoing Venue Engagement</h3>
                        <p class="text-[16px] md:text-[20px] text-gray-300 mb-[24px] md:mb-[32px] leading-relaxed">
                            A standalone subscription service that continually engages customers and increases revenue. Perfect for bars, restaurants, lounges, and hospitality spaces.
                        </p>

                        <div class="bg-purple-500/10 border-l-[4px] border-purple-500 rounded-[8px] p-[16px] md:p-[24px] mb-[24px]">
                            <h4 class="text-[16px] md:text-[18px] font-garamond mb-[12px] text-purple-300">How It Works:</h4>
                            <p class="text-[14px] md:text-[16px] text-gray-300 mb-[16px] leading-relaxed">
                                One simple QR code allows customers to scan, engage with prompts, earn rewards, and increase dwell time — continuously driving customer engagement and spending.
                            </p>
                        </div>

                        <h4 class="text-[18px] md:text-[20px] mb-[16px] font-garamond text-white">What your venue gets:</h4>
                        <ul class="space-y-[12px] md:space-y-[16px] mb-[24px]">
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="qr-code" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-purple-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">QR-based customer engagement system</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="dollar-sign" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-purple-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Increased dwell time and customer spending</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="users" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-purple-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Real-time customer interaction and connection</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="coins" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-purple-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Token rewards that drive return visits</span>
                            </li>
                        </ul>

                        <div class="bg-gradient-to-r from-purple-500/20 to-pink-500/20 border border-purple-500/40 rounded-[8px] p-[16px] mb-[24px] md:mb-[32px]">
                            <h4 class="text-[14px] md:text-[16px] font-garamond mb-[8px] text-purple-300">Separate Service:</h4>
                            <p class="text-[12px] md:text-[14px] text-gray-300">VibeLink operates independently from Wildcard events. It's an ongoing subscription system designed specifically for bars, restaurants, lounges, and venues seeking continuous customer engagement.</p>
                        </div>

                        <a href="https://vest-mug-66210004.figma.site" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-[8px] px-[24px] py-[12px] bg-purple-500 hover:bg-purple-600 text-white rounded-[8px] transition-all shadow-lg group w-fit">
                            <i data-lucide="map-pin" class="w-[20px] h-[20px]"></i>
                            <span>Launch VibeLink Experience</span>
                            <i data-lucide="chevron-right" class="w-[20px] h-[20px] group-hover:translate-x-[4px] transition-transform"></i>
                        </a>
                    </div>
                    <div class="bg-gradient-to-br from-white/5 to-transparent p-[24px] md:p-[48px] flex flex-col gap-[24px] md:border-l border-white/10 min-h-[400px] rounded-r-[16px]">
                        <div class="relative w-full h-full flex items-center justify-center" id="vibelink-interaction-container">
                            ${renderSkeletonLoader()}
                        </div>
                    </div>
                </div>
            `;
        }

        if (nodeId === 'beyond-the-room') {
            return `
                <div class="w-full grid md:grid-cols-2 md:min-h-[600px]">
                    <div class="p-[24px] md:p-[48px] flex flex-col justify-center">
                        <!-- Media Embed Area -->
                        <div class="relative w-full aspect-video rounded-[12px] overflow-hidden mb-[24px] shadow-2xl">
                            <img src="https://cdn.shopify.com/s/files/1/0328/9032/3077/files/artifact_portal.gif?v=1778831994" alt="Artifact Portal visualization" class="w-full h-full object-cover">
                        </div>
                        
                        <h3 class="font-garamond text-[30px] md:text-[48px] mb-[16px] md:mb-[24px] text-white">Beyond the Room</h3>
                        <p class="text-[16px] md:text-[20px] text-gray-300 mb-[24px] md:mb-[32px] leading-relaxed">
                            Your participation continues after the event through the Artifact Portal.
                        </p>
                        <h4 class="text-[18px] md:text-[20px] mb-[16px] font-garamond text-white">What happens:</h4>
                        <ul class="space-y-[12px] md:space-y-[16px] mb-[24px]">
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="sparkles" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-pink-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Your responses become part of a growing archive</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="message-circle" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-pink-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">Continue engaging with prompts after the night</span>
                            </li>
                            <li class="flex items-start gap-[12px]">
                                <i data-lucide="archive" class="w-[20px] h-[20px] md:w-[24px] md:h-[24px] text-pink-400 flex-shrink-0 mt-[4px]"></i>
                                <span class="text-[14px] md:text-[16px] text-gray-300">See how your community's perspectives evolve over time</span>
                            </li>
                        </ul>
                        <div class="bg-pink-500/10 border border-pink-500/30 rounded-[8px] p-[16px] mb-[24px] md:mb-[32px]">
                            <h4 class="text-[14px] md:text-[16px] font-garamond mb-[8px] text-pink-400">What happens in the room doesn't stay in the room:</h4>
                            <p class="text-[12px] md:text-[14px] text-gray-300 leading-relaxed">This is not just an event—it's a system. Your voice lives on, hosts gain real cultural insights, and Wildcard grows through every contribution.</p>
                        </div>
                        <a href="https://artifact.vibesandvirtues.com" target="_blank" rel="noopener noreferrer" class="inline-flex items-center gap-[8px] px-[24px] py-[12px] bg-pink-500 hover:bg-pink-600 text-white rounded-[8px] transition-all shadow-lg group w-fit">
                            <i data-lucide="globe" class="w-[20px] h-[20px]"></i>
                            <span>Explore the Portal Experience</span>
                            <i data-lucide="chevron-right" class="w-[20px] h-[20px] group-hover:translate-x-[4px] transition-transform"></i>
                        </a>
                    </div>
                    <div class="bg-gradient-to-br from-white/5 to-transparent p-[24px] md:p-[48px] flex flex-col gap-[24px] md:border-l border-white/10 min-h-[400px] rounded-r-[16px] overflow-hidden">
                        <div class="relative w-full h-full flex items-center justify-center" id="beyond-interaction-container">
                            ${renderSkeletonLoader()}
                        </div>
                    </div>
                </div>
            `;
        }

        return '';
    };

    const renderPuzzleInteraction = () => {
        const assembled = systemState.puzzleAssembled;
        const wPattern = [0, 1, 2, 3, 5, 6, 7, 8];
        const isMobile = window.innerWidth < 768;
        const scatterDistance = isMobile ? 75 : 120;
        const assembledDistance = isMobile ? 55 : 70;
        const marginTop = isMobile ? '130px' : '240px';

        return `
            <div class="relative w-full h-full flex flex-col items-center justify-center">
                <div class="grid grid-cols-3 gap-[16px] mb-[32px]" id="puzzle-grid">
                    ${[...Array(9)].map((_, i) => {
            const isPartOfW = wPattern.includes(i);
            const randomRotate = (i * 47) % 360;
            const x = (i % 3 - 1) * (assembled ? assembledDistance : scatterDistance);
            const y = (Math.floor(i / 3) - 1) * (assembled ? assembledDistance : scatterDistance);
            const rotation = assembled ? 0 : randomRotate;
            const opacity = assembled && !isPartOfW ? '0.3' : '1';
            const scale = assembled && !isPartOfW ? '0.8' : '1';
            const bg = assembled
                ? (isPartOfW ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' : 'rgba(239, 68, 68, 0.2)')
                : 'linear-gradient(135deg, #ef4444 0%, #f97316 100%)';

            return `
                            <div class="absolute w-[48px] h-[48px] md:w-[64px] md:h-[64px] rounded-[8px] flex items-center justify-center cursor-pointer transition-all duration-700 shadow-lg"
                                 style="transform: translate(${x}px, ${y}px) rotate(${rotation}deg) scale(${scale}); background: ${bg}; opacity: ${opacity};"
                                 onclick="togglePuzzleAssembly()">
                                ${assembled && isPartOfW ? '<i data-lucide="puzzle" class="w-[24px] h-[24px] md:w-[32px] md:h-[32px] text-white"></i>' : `<span class="text-white/50 text-[10px] md:text-[12px]">${i + 1}</span>`}
                            </div>
                        `;
        }).join('')}
                </div>
                <p class="text-[14px] text-gray-400 italic" style="margin-top: ${marginTop};">
                    ${assembled ? 'Click to scatter' : 'Click pieces to assemble'}
                </p>
            </div>
        `;
    };

    window.togglePuzzleAssembly = () => {
        systemState.puzzleAssembled = !systemState.puzzleAssembled;
        const container = document.getElementById('puzzle-interaction-container');
        if (container) {
            container.innerHTML = renderPuzzleInteraction();
            if (typeof lucide !== 'undefined') lucide.createIcons({ root: container });
        }
    };

    const renderMusicInteraction = () => {
        const layers = systemState.experienceLayers || 1;
        return `
            <div class="flex flex-col items-center gap-[40px] w-full max-w-[448px]">
                <!-- Collaborators Circles -->
                <div class="flex gap-[16px] mb-[16px]">
                    ${[...Array(layers)].map((_, i) => `
                        <div class="relative animate-scaleIn" style="animation-delay: ${i * 0.1}s">
                            <div class="w-[50px] h-[50px] md:w-[64px] md:h-[64px] rounded-[9999px] bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-xl relative z-10">
                                <i data-lucide="users" class="w-[24px] h-[24px] md:w-[32px] md:h-[32px] text-white"></i>
                            </div>
                            <div class="absolute inset-0 bg-blue-500/20 blur-xl rounded-[9999px] animate-pulse"></div>
                        </div>
                    `).join('')}
                </div>

                <!-- Layered Waveforms -->
                <div class="relative w-full h-32 flex flex-col items-center justify-center">
                    ${[...Array(layers)].map((_, i) => `
                        <div class="absolute inset-x-0 flex items-center justify-center gap-1" style="top: ${i * 20}px">
                            ${[...Array(20)].map((_, j) => {
            const midHeight = 20 + ((j * 23) % 60);
            const duration = 0.8 + (Math.random() * 0.4);
            return `
                                    <div class="w-[6px] md:w-[8px] bg-blue-500 rounded-[9999px] animate-music-bar" 
                                         style="height: ${midHeight}px; animation-duration: ${duration}s; animation-delay: ${j * 0.05 + i * 0.1}s"></div>
                                `;
        }).join('')}
                        </div>
                    `).join('')}
                </div>

                <!-- Button -->
                <div class="flex flex-col items-center gap-[24px] w-full">
                    <button onclick="addMusicLayer()" 
                        class="w-full px-6 py-3 border border-blue-500 text-white hover:bg-blue-500/10 transition-all rounded-[8px] font-medium text-[16px] shadow-lg active:scale-95">
                        ${layers < 4 ? 'Add Collaborating Artist' : 'Reset'}
                    </button>
                    <p class="text-[12px] text-gray-500 uppercase tracking-widest font-medium">Click to layer collaborating artists</p>
                </div>
            </div>
        `;
    };

    window.addMusicLayer = () => {
        systemState.experienceLayers = systemState.experienceLayers < 4 ? systemState.experienceLayers + 1 : 1;
        const container = document.getElementById('music-interaction-container');
        if (container) {
            container.innerHTML = renderMusicInteraction();
            if (typeof lucide !== 'undefined') lucide.createIcons({ root: container });
        }
    };

    window.renderTokenInteraction = () => {
        const { count, showOptions } = systemState.tokenSimulation;
        return `
            <div class="bg-black/40 border border-green-500/30 rounded-[12px] p-[24px] w-full max-w-[384px]">
                <div class="flex items-center justify-between mb-[16px]">
                    <h4 class="font-garamond text-[20px] text-green-300">Try It Out</h4>
                    <div class="flex items-center gap-[8px] px-3 py-1 bg-green-500/20 rounded-[9999px] border border-green-500/40">
                        <i data-lucide="coins" class="w-[16px] h-[16px] text-green-400"></i>
                        <span class="text-[14px] text-green-300 font-bold">${count} tokens</span>
                    </div>
                </div>

                <button onclick="window.simulateTokenEarn()" class="w-full px-6 py-3 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-400 hover:to-orange-400 text-black rounded-[8px] transition-all shadow-lg mb-[16px] font-medium active:scale-95">
                    Answer a Prompt (+10 tokens)
                </button>

                <div class="space-y-2 overflow-hidden transition-all duration-500" style="max-height: ${showOptions ? '400px' : '0px'}; opacity: ${showOptions ? '1' : '0'}">
                    <p class="text-[12px] text-gray-400 mb-[12px]">Use your tokens:</p>
                    <button onclick="window.simulateTokenSpend(15, 'drink')" ${count < 15 ? 'disabled' : ''} class="w-full px-4 py-2 bg-white/10 hover:bg-white/20 disabled:bg-white/5 disabled:text-gray-600 text-gray-200 rounded-[8px] text-[14px] transition-all flex items-center justify-between">
                        <span>Redeem for drink</span>
                        <span class="text-[12px]">-15 tokens</span>
                    </button>
                    <button onclick="window.simulateTokenSpend(25, 'merch')" ${count < 25 ? 'disabled' : ''} class="w-full px-4 py-2 bg-white/10 hover:bg-white/20 disabled:bg-white/5 disabled:text-gray-600 text-gray-200 rounded-[8px] text-[14px] transition-all flex items-center justify-between">
                        <span>Redeem for merch</span>
                        <span class="text-[12px]">-25 tokens</span>
                    </button>
                    <button onclick="window.simulateTokenSpend(20, 'vendor')" ${count < 20 ? 'disabled' : ''} class="w-full px-4 py-2 bg-white/10 hover:bg-white/20 disabled:bg-white/5 disabled:text-gray-600 text-gray-200 rounded-[8px] text-[14px] transition-all flex items-center justify-between">
                        <span>Redeem with vendor</span>
                        <span class="text-[12px]">-20 tokens</span>
                    </button>
                </div>
            </div>
        `;
    };

    window.simulateTokenEarn = () => {
        systemState.tokenSimulation.count += 10;
        systemState.tokenSimulation.showOptions = true;
        updateTokenUI();
    };

    window.simulateTokenSpend = (amount, type) => {
        if (systemState.tokenSimulation.count >= amount) {
            systemState.tokenSimulation.count -= amount;
            updateTokenUI();

            // Visual feedback
            const container = document.getElementById('token-interaction-container');
            const feedback = document.createElement('div');
            feedback.className = 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-green-500 text-white px-4 py-2 rounded-[9999px] font-bold animate-fade-out-up z-50';
            feedback.innerText = `Enjoy your ${type}!`;
            container.appendChild(feedback);
            setTimeout(() => feedback.remove(), 2000);
        }
    };

    const updateTokenUI = () => {
        const container = document.getElementById('token-interaction-container');
        if (container) {
            container.innerHTML = window.renderTokenInteraction();
            if (typeof lucide !== 'undefined') lucide.createIcons({ root: container });
        }
    };

    window.renderTokenFlowAnimation = () => {
        return `
            <div class="relative w-full h-full flex flex-col items-center justify-center gap-[32px] md:gap-[48px]">
                <div class="flex justify-between items-center w-full px-[16px] md:px-[32px]">
                    <!-- Engage Node -->
                    <div class="flex flex-col items-center gap-[8px]">
                        <div class="w-[80px] h-[80px] md:w-[96px] md:h-[96px] rounded-full bg-green-500/20 border-[2px] border-green-500 flex items-center justify-center shadow-lg backdrop-blur-sm relative">
                            <i data-lucide="users" class="w-[40px] h-[40px] md:w-[48px] md:h-[48px] text-green-400"></i>
                            <div class="absolute inset-0 rounded-full border-2 border-green-400 opacity-30 animate-ping" style="animation-duration: 3s;"></div>
                        </div>
                        <span class="text-[12px] md:text-[14px] text-green-400 font-medium">Engage</span>
                    </div>

                    <!-- Flowing Line & Coins -->
                    <div class="flex-1 relative h-[8px] mx-[16px] md:mx-[32px] bg-gradient-to-r from-green-500/30 to-yellow-500/30 rounded-full">
                        <div id="flowing-tokens-container" class="absolute inset-0 pointer-events-none">
                            ${systemState.tokenFlowing ? `
                                <div class="absolute w-[32px] h-[32px] md:w-[40px] md:h-[40px] rounded-full bg-gradient-to-br from-green-400 to-green-600 shadow-lg flex items-center justify-center border-2 border-green-300 token-particle" style="animation-delay: 0s; transform: translate(-50%, -50%);">
                                    <i data-lucide="coins" class="w-[18px] h-[18px] md:w-[22px] md:h-[22px] text-white"></i>
                                </div>
                                <div class="absolute w-[32px] h-[32px] md:w-[40px] md:h-[40px] rounded-full bg-gradient-to-br from-green-400 to-green-600 shadow-lg flex items-center justify-center border-2 border-green-300 token-particle" style="animation-delay: 0.6s; transform: translate(-50%, -50%);">
                                    <i data-lucide="coins" class="w-[18px] h-[18px] md:w-[22px] md:h-[22px] text-white"></i>
                                </div>
                                <div class="absolute w-[32px] h-[32px] md:w-[40px] md:h-[40px] rounded-full bg-gradient-to-br from-green-400 to-green-600 shadow-lg flex items-center justify-center border-2 border-green-300 token-particle" style="animation-delay: 1.2s; transform: translate(-50%, -50%);">
                                    <i data-lucide="coins" class="w-[18px] h-[18px] md:w-[22px] md:h-[22px] text-white"></i>
                                </div>
                                <div class="absolute w-[32px] h-[32px] md:w-[40px] md:h-[40px] rounded-full bg-gradient-to-br from-green-400 to-green-600 shadow-lg flex items-center justify-center border-2 border-green-300 token-particle" style="animation-delay: 1.8s; transform: translate(-50%, -50%);">
                                    <i data-lucide="coins" class="w-[18px] h-[18px] md:w-[22px] md:h-[22px] text-white"></i>
                                </div>
                                <div class="absolute w-[32px] h-[32px] md:w-[40px] md:h-[40px] rounded-full bg-gradient-to-br from-green-400 to-green-600 shadow-lg flex items-center justify-center border-2 border-green-300 token-particle" style="animation-delay: 2.4s; transform: translate(-50%, -50%);">
                                    <i data-lucide="coins" class="w-[18px] h-[18px] md:w-[22px] md:h-[22px] text-white"></i>
                                </div>
                            ` : ''}
                        </div>
                    </div>

                    <!-- Redeem Node -->
                    <div class="flex flex-col items-center gap-[8px]">
                        <div class="w-[80px] h-[80px] md:w-[96px] md:h-[96px] rounded-full bg-yellow-500/20 border-[2px] border-yellow-500 flex items-center justify-center shadow-lg backdrop-blur-sm relative">
                            <i data-lucide="dollar-sign" class="w-[40px] h-[40px] md:w-[48px] md:h-[48px] text-yellow-400"></i>
                            <div class="absolute inset-0 rounded-full border-2 border-yellow-400 opacity-30 animate-ping" style="animation-duration: 3s; animation-delay: 1.5s;"></div>
                        </div>
                        <span class="text-[12px] md:text-[14px] text-yellow-400 font-medium">Redeem</span>
                    </div>
                </div>

                <div class="text-center space-y-[8px] max-w-[320px]">
                    <p class="text-[12px] md:text-[14px] text-gray-400">
                        Earn through prompts & dialogue → Redeem at businesses, V&V, Wildcard
                    </p>
                </div>

                <button onclick="window.toggleTokenFlow()" type="button" class="px-[24px] py-[12px] border border-green-500 bg-green-500/10 hover:bg-green-500/20 text-green-300 transition-colors rounded-[8px] backdrop-blur-sm font-medium flex items-center gap-[8px] active:scale-95 cursor-pointer z-50">
                    <i data-lucide="${systemState.tokenFlowing ? 'pause' : 'play'}" class="w-[16px] h-[16px]"></i>
                    <span>${systemState.tokenFlowing ? 'Pause' : 'See Token Flow'}</span>
                </button>
            </div>
        `;
    };

    window.toggleTokenFlow = () => {
        systemState.tokenFlowing = !systemState.tokenFlowing;
        console.log(systemState.tokenFlowing);
        const container = document.getElementById('token-flow-container');
        if (container) {
            container.innerHTML = window.renderTokenFlowAnimation();
            if (typeof lucide !== 'undefined') lucide.createIcons({ root: container });
        }
    };
        return '';
    };

    const renderPuzzleInteraction = () => {
        const assembled = systemState.puzzleAssembled;
        const wPattern = [0, 1, 2, 3, 5, 6, 7, 8];
        const isMobile = window.innerWidth < 768;
        const scatterDistance = isMobile ? 75 : 120;
        const assembledDistance = isMobile ? 55 : 70;
        const marginTop = isMobile ? '130px' : '240px';

        return `
            <div class="relative w-full h-full flex flex-col items-center justify-center">
                <div class="grid grid-cols-3 gap-[16px] mb-[32px]" id="puzzle-grid">
                    ${[...Array(9)].map((_, i) => {
            const isPartOfW = wPattern.includes(i);
            const randomRotate = (i * 47) % 360;
            const x = (i % 3 - 1) * (assembled ? assembledDistance : scatterDistance);
            const y = (Math.floor(i / 3) - 1) * (assembled ? assembledDistance : scatterDistance);
            const rotation = assembled ? 0 : randomRotate;
            const opacity = assembled && !isPartOfW ? '0.3' : '1';
            const scale = assembled && !isPartOfW ? '0.8' : '1';
            const bg = assembled
                ? (isPartOfW ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' : 'rgba(239, 68, 68, 0.2)')
                : 'linear-gradient(135deg, #ef4444 0%, #f97316 100%)';

            return `
                            <div class="absolute w-[48px] h-[48px] md:w-[64px] md:h-[64px] rounded-[8px] flex items-center justify-center cursor-pointer transition-all duration-700 shadow-lg"
                                 style="transform: translate(${x}px, ${y}px) rotate(${rotation}deg) scale(${scale}); background: ${bg}; opacity: ${opacity};"
                                 onclick="togglePuzzleAssembly()">
                                ${assembled && isPartOfW ? '<i data-lucide="puzzle" class="w-[24px] h-[24px] md:w-[32px] md:h-[32px] text-white"></i>' : `<span class="text-white/50 text-[10px] md:text-[12px]">${i + 1}</span>`}
                            </div>
                        `;
        }).join('')}
                </div>
                <p class="text-[14px] text-gray-400 italic" style="margin-top: ${marginTop};">
                    ${assembled ? 'Click to scatter' : 'Click pieces to assemble'}
                </p>
            </div>
        `;
    };

    window.togglePuzzleAssembly = () => {
        systemState.puzzleAssembled = !systemState.puzzleAssembled;
        const container = document.getElementById('puzzle-interaction-container');
        if (container) {
            container.innerHTML = renderPuzzleInteraction();
            if (typeof lucide !== 'undefined') lucide.createIcons();
        }
    };

// Global scroll functions
window.scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    const navMenu = document.getElementById('nav-menu');
    const menuIcon = document.getElementById('menu-icon');
    const closeIcon = document.getElementById('close-icon');

    if (element) {
        element.scrollIntoView({
            behavior: 'smooth'
        });
    }
    // Close mobile menu if open
    if (navMenu && !navMenu.classList.contains('hidden')) {
        navMenu.classList.add('hidden');
        if (menuIcon) menuIcon.classList.remove('hidden');
        if (closeIcon) closeIcon.classList.add('hidden');
    }
};

window.scrollToQuestion = (index) => {
    const questionId = `question-${index}`;
    const element = document.getElementById(questionId);
    if (element) {
        // Scroll to the section first
        const questionsSection = document.getElementById('questions');
        if (questionsSection) {
            questionsSection.scrollIntoView({
                behavior: 'smooth'
            });
        }

        // Small delay to allow section scroll then scroll to specific card
        setTimeout(() => {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });

            // Highlight effect
            element.classList.add('ring-4', 'ring-yellow-400', 'ring-opacity-70', 'scale-[1.05]', 'z-50');

            // Expand if hidden
            const promptText = element.querySelector('.prompt-text');
            const fullText = element.querySelector('.full-text');
            if (promptText && !promptText.classList.contains('hidden')) {
                promptText.classList.add('hidden');
                if (fullText) fullText.classList.remove('hidden');
            }

            // Remove highlight after 2 seconds
            setTimeout(() => {
                element.classList.remove('ring-4', 'ring-yellow-400', 'ring-opacity-70', 'scale-[1.05]', 'z-50');
            }, 2000);
        }, 500);
    }
};



let currentWalkthroughSlide = 0;

window.showWalkthroughModal = () => {
    const modal = document.getElementById('walkthrough-modal');
    const content = document.getElementById('walkthrough-content');
    if (!modal) return;

    modal.classList.remove('hidden');
    setTimeout(() => {
        content.classList.remove('scale-95', 'opacity-0');
        content.classList.add('scale-100', 'opacity-100');
    }, 10);

    renderWalkthroughSlide(0);
    document.body.style.overflow = 'hidden';
};

window.closeWalkthroughModal = () => {
    const modal = document.getElementById('walkthrough-modal');
    const content = document.getElementById('walkthrough-content');
    content.classList.remove('scale-100', 'opacity-100');
    content.classList.add('scale-95', 'opacity-0');
    setTimeout(() => {
        modal.classList.add('hidden');
        document.body.style.overflow = '';
    }, 500);
};

const renderWalkthroughSlide = (index) => {
    const container = document.getElementById('walkthrough-slides-container');
    const slide = walkthroughSlides[index];
    if (!container) return;

    container.innerHTML = `
        <div class="h-full flex flex-col items-center justify-center px-[30px] md:px-[80px] pt-[15%] overflow-y-auto text-center animate-fade-in">
            <!-- Icon -->
            <div class="w-[120px] h-[120px] md:w-[160px] md:h-[160px] mb-[48px] flex items-center justify-center relative">
                <div class="absolute inset-0 bg-yellow-400/20 blur-[40px] rounded-full animate-pulse"></div>
                <i data-lucide="${slide.icon}" class="w-[80px] h-[80px] md:w-[100px] md:h-[100px] ${slide.color} relative z-10 filter drop-shadow-[0_0_15px_rgba(255,255,255,0.3)]"></i>
            </div>
            
            <!-- Content -->
            <div class="max-w-[800px] mx-auto">
                <h2 class="font-garamond text-[32px] md:text-[54px] text-white leading-tight mb-[4px]">
                    ${slide.title}
                </h2>
                <h2 class="font-garamond text-[32px] md:text-[54px] text-white leading-tight mb-[8px]">
                    ${slide.subtitle}
                </h2>
                <h3 class="font-garamond text-[28px] md:text-[46px] text-yellow-400 leading-tight mb-[24px]">
                    ${slide.highlight}
                </h3>
                <p class="text-gray-400 text-[16px] md:text-[18px] max-w-[600px] mx-auto leading-relaxed">
                    ${slide.subtext}
                </p>
               
            </div>


             <img class="w-[90%] max-w-[550px] aspect-[1.4/1] object-cover mt-[30px] mb-[80px]" src="${slide.img}" alt="${slide.title}" />
        </div>
    `;

    currentWalkthroughSlide = index;
    updateWalkthroughControls();
    if (typeof lucide !== 'undefined') lucide.createIcons({ root: container });
};

const updateWalkthroughControls = () => {
    const topDotsContainer = document.getElementById('walkthrough-dots-top');
    const counterDisplay = document.getElementById('walkthrough-counter');
    const prevBtn = document.getElementById('walkthrough-prev');
    const nextBtn = document.getElementById('walkthrough-next');

    // Update Counter
    if (counterDisplay) {
        counterDisplay.innerText = `${currentWalkthroughSlide + 1} / ${walkthroughSlides.length}`;
    }

    // Update Top Dots
    if (topDotsContainer) {
        topDotsContainer.innerHTML = walkthroughSlides.map((_, i) => `
            <div class="h-[4px] rounded-full transition-all duration-300 ${i === currentWalkthroughSlide ? 'bg-yellow-400 w-[32px]' : 'bg-white/20 w-[12px]'}"></div>
        `).join('');
    }

    // Update Side Buttons
    if (prevBtn) {
        if (currentWalkthroughSlide === 0) {
            prevBtn.classList.add('opacity-0', 'pointer-events-none');
        } else {
            prevBtn.classList.remove('opacity-0', 'pointer-events-none');
        }
    }

    if (nextBtn) {
        const icon = nextBtn.querySelector('i');
        if (currentWalkthroughSlide === walkthroughSlides.length - 1) {
            if (icon) icon.setAttribute('data-lucide', 'check');
            nextBtn.classList.add('bg-green-500');
            nextBtn.classList.remove('bg-yellow-400');
        } else {
            if (icon) icon.setAttribute('data-lucide', 'chevron-right');
            nextBtn.classList.remove('bg-green-500');
            nextBtn.classList.add('bg-yellow-400');
        }
        if (typeof lucide !== 'undefined') lucide.createIcons({ root: nextBtn });
    }
};

window.navigateWalkthrough = (direction) => {
    if (direction === 'next') {
        if (currentWalkthroughSlide < walkthroughSlides.length - 1) {
            renderWalkthroughSlide(currentWalkthroughSlide + 1);
        } else {
            closeWalkthroughModal();
        }
    } else {
        if (currentWalkthroughSlide > 0) {
            renderWalkthroughSlide(currentWalkthroughSlide - 1);
        }
    }
};

// Artifact Portal Auto-Advance & Height Equalization
let currentArtifactStep = 0;
const artifactSteps = [
    { title: "Engage in the Experience", desc: "Puzzle piece interaction, people writing responses", icon: "sparkles" },
    { title: "Share Your Perspective", desc: "Handwritten responses lifting off the wall", icon: "message-circle" },
    { title: "Enter the Portal", desc: "Particles flow into a digital interface", icon: "globe" },
    { title: "Continue the Conversation", desc: "Mobile interface with cycling prompts", icon: "chevron-right" },
    { title: "Become Part of the Archive", desc: "Nodes connecting across a map or network", icon: "archive" }
];

const equalizeArtifactHeights = () => {
    const display = document.getElementById('artifact-display');
    const iconContainer = document.getElementById('artifact-icon');
    const titleContainer = document.getElementById('artifact-title');
    const descContainer = document.getElementById('artifact-desc');

    if (!display || !artifactSteps.length) return;

    let maxHeight = 0;

    // Save current content to restore later
    const savedIcon = iconContainer.innerHTML;
    const savedTitle = titleContainer.innerText;
    const savedDesc = descContainer.innerText;

    // Temporarily disable transitions for measurement
    display.style.transition = 'none';
    display.style.minHeight = '0px';

    artifactSteps.forEach(step => {
        if (iconContainer) iconContainer.innerHTML = `<i data-lucide="${step.icon}" class="w-[48px] h-[48px]"></i>`;
        if (titleContainer) titleContainer.innerText = step.title;
        if (descContainer) descContainer.innerText = step.desc;

        const h = display.scrollHeight;
        if (h > maxHeight) maxHeight = h;
    });

    // Restore original content and set min-height
    iconContainer.innerHTML = savedIcon;
    titleContainer.innerText = savedTitle;
    descContainer.innerText = savedDesc;
    display.style.minHeight = `${maxHeight + 20}px`;
    display.style.transition = '';
};

// Initialize heights on load and resize
setTimeout(equalizeArtifactHeights, 1000);
window.addEventListener('resize', equalizeArtifactHeights);

let artifactInterval = null;
const startArtifactAutoplay = () => {
    const artifactDisplay = document.getElementById('artifact-display');
    if (!artifactDisplay || artifactInterval) return;

    artifactInterval = setInterval(() => {
        const artifactIcon = document.getElementById('artifact-icon');
        const artifactTitle = document.getElementById('artifact-title');
        const artifactDesc = document.getElementById('artifact-desc');
        const artifactDots = document.querySelectorAll('.artifact-dot');

        currentArtifactStep = (currentArtifactStep + 1) % artifactSteps.length;

        artifactDisplay.style.opacity = 0;
        setTimeout(() => {
            const step = artifactSteps[currentArtifactStep];
            if (artifactIcon) artifactIcon.innerHTML = `<i data-lucide="${step.icon}" class="w-[48px] h-[48px]"></i>`;
            if (artifactTitle) artifactTitle.innerText = step.title;
            if (artifactDesc) artifactDesc.innerText = step.desc;
            if (typeof lucide !== 'undefined') lucide.createIcons({ root: artifactIcon });

            artifactDots.forEach((dot, i) => {
                dot.style.width = i === currentArtifactStep ? '3rem' : '0.75rem';
                dot.style.backgroundColor = i === currentArtifactStep ? '#facc15' : 'rgba(255, 255, 255, 0.3)';
            });

            artifactDisplay.style.opacity = 1;
        }, 500);
    }, 4000);
};

const stopArtifactAutoplay = () => {
    if (artifactInterval) {
        clearInterval(artifactInterval);
        artifactInterval = null;
    }
};

const initArtifactAutoplay = () => {
    const artifactDisplay = document.getElementById('artifact-display');
    if (!artifactDisplay) return;
    artifactDisplay._startAutoplay = startArtifactAutoplay;
    artifactDisplay._stopAutoplay = stopArtifactAutoplay;
    startArtifactAutoplay();
};

initArtifactAutoplay();

// --- Puzzle Themes Modal Logic ---
const puzzlePiecesData = [
    { id: 1, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/New_Beginnings.webp?v=1778502366', theme: 'New Beginnings', month: 'January', desc: 'Renewal and hope for fresh starts', youtube: 'VgT98iFtiFA' },
    { id: 2, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Roots_of_Love_1.webp?v=1778502527', theme: 'Roots of Love', month: 'February', desc: 'Exploring the deep foundations of love and connection', youtube: 'Jkm1uGk_xB0' },
    { id: 3, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/She_Reigns.webp?v=1778502605', theme: 'She Reigns!', month: 'March', desc: "Celebrating women's power and leadership", youtube: '1EPyrMiNDGg' },
    { id: 4, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/World_of_Waste.webp?v=1778502859', theme: 'World of Waste', month: 'April', desc: 'Confronting environmental challenges and sustainability', youtube: 'xKE64qLf5uE' },
    { id: 5, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Echoes_of_the_East.webp?v=1778501703', theme: 'Echoes of the East', month: 'May', desc: 'Exploring Eastern cultural influences and heritage', youtube: 'z4yLDu5ZOCQ' },
    { id: 6, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Fathers_of_Change.webp?v=1778502141', theme: 'Fathers of Change', month: 'June', desc: 'Honoring fathers and father figures who inspire transformation', youtube: 'xHBJJEB8ei4' },
    { id: 7, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Unapologettically_Proud.webp?v=1778502694', theme: 'Unapologetically Proud', month: 'June', desc: 'Celebrating LGBTQ+ pride and authentic self-expression', youtube: 'yKUOfNcKb_0' },
    { id: 8, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Patriot_Paradox.webp?v=1778502415', theme: 'Patriot Paradox', month: 'July', desc: 'Examining what it means to be patriotic in modern America', youtube: 'kp0bszEvghw' },
    { id: 9, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Class_Act.webp?v=1778501401', theme: 'Class Act', month: 'August', desc: 'Exploring class, education, and social mobility', youtube: 'jJs3pq94jEk' },
    { id: 10, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Fall_Forward.webp?v=1778502078', theme: 'Fall Forward', month: 'September', desc: 'Embracing failure as a stepping stone to growth', youtube: 'tgBK2vjng2g' },
    { id: 11, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Fright_to_Vote.webp?v=1778502195', theme: 'Fright to Vote', month: 'October', desc: 'Confronting the fears and power of democratic participation', youtube: 'qcBG95-Ewrk' },
    { id: 12, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Gather_Round.webp?v=1778502296', theme: 'Gather Round', month: 'November', desc: 'Coming together in gratitude and community', youtube: 'YNLkEqkdcH4' },
    { id: 13, image: 'https://cdn.shopify.com/s/files/1/0328/9032/3077/files/Under_the_Mistletoe.webp?v=1778502751', theme: 'Under the Mistletoe', month: 'December', desc: 'Finding connection and warmth in the holiday season', youtube: 'uJOAuNOsy1A' }
];

let puzzleOrbitAnimation;
let isPuzzlePaused = false;
let currentSelectedPieceIndex = 0;

function openPuzzleModal() {
    const modal = document.getElementById('puzzle-modal');
    const content = document.getElementById('puzzle-modal-content');
    modal.classList.remove('hidden');
    setTimeout(() => {
        content.classList.remove('scale-95', 'opacity-0');
        content.classList.add('scale-100', 'opacity-100');
    }, 10);
    document.body.style.overflow = 'hidden';
    initPuzzleOrbit();
}

function closePuzzleModal() {
    const modal = document.getElementById('puzzle-modal');
    const content = document.getElementById('puzzle-modal-content');
    content.classList.remove('scale-100', 'opacity-100');
    content.classList.add('scale-95', 'opacity-0');
    setTimeout(() => {
        modal.classList.add('hidden');
        document.body.style.overflow = '';
        if (puzzleOrbitAnimation) cancelAnimationFrame(puzzleOrbitAnimation);

        // Free up memory by clearing dynamic orbit pieces
        const container = document.getElementById('puzzle-orbit-container');
        if (container) {
            container.innerHTML = '';
        }
    }, 300);
}

function togglePuzzleOrbit() {
    isPuzzlePaused = !isPuzzlePaused;
    const btn = document.getElementById('puzzle-pause-btn');
    if (btn) btn.innerText = isPuzzlePaused ? 'Resume' : 'Pause';
}

function initPuzzleOrbit() {
    const container = document.getElementById('puzzle-orbit-container');
    if (!container) return;

    const existingPieces = container.querySelectorAll('.orbit-piece');
    existingPieces.forEach(p => p.remove());

    // Cache once — never read these inside the RAF loop
    const radius = window.innerWidth < 768 ? 130 : 320;
    const isMobile = window.innerWidth < 768;
    const detailModal = document.getElementById('piece-detail-modal');
    const anglePerPiece = 360 / puzzlePiecesData.length;

    let rotation = 0;
    let lastTime = 0;
    let prevCenterIndex = -1;

    const piecesElements = puzzlePiecesData.map((piece, i) => {
        const el = document.createElement('div');
        el.className = 'absolute cursor-pointer orbit-piece';
        el.style.willChange = 'transform, opacity';
        el.innerHTML = `
            <div class="relative">
                <img src="${piece.image}" alt="${piece.theme}" onerror="this.src='https://cdn.shopify.com/s/files/1/0328/9032/3077/files/DSC0818_1.webp?v=1778499573'" class="w-20 h-20 md:w-32 md:h-32 object-cover rounded-[8px] shadow-2xl border-2 border-white/20">
                <div class="piece-tooltip absolute -bottom-16 left-1/2 -translate-x-1/2 whitespace-nowrap transition-opacity duration-300 z-50" style="opacity:0;pointer-events:none;">
                    <div class="bg-black/90 backdrop-blur-sm border border-white/20 rounded-[8px] px-4 py-2">
                        <p class="text-white font-medium text-[14px]">${piece.theme}</p>
                        <p class="text-gray-400 text-[12px]">${piece.month}</p>
                    </div>
                </div>
            </div>
        `;
        el.onclick = () => openPieceDetail(i);
        // Hover tooltips via events — NOT inside the animation loop
        el.addEventListener('mouseenter', () => { el.querySelector('.piece-tooltip').style.opacity = '1'; });
        el.addEventListener('mouseleave', () => { el.querySelector('.piece-tooltip').style.opacity = '0'; });
        container.appendChild(el);
        return el;
    });

    // Cache tooltip refs once — never use querySelector inside animate()
    const tooltips = piecesElements.map(el => el.querySelector('.piece-tooltip'));

    const animate = (time) => {
        if (!lastTime) lastTime = time;
        const delta = time - lastTime;
        lastTime = time;

        if (!isPuzzlePaused && detailModal.classList.contains('hidden')) {
            rotation = (rotation + delta * 0.015) % 360;
        }

        const normalizedRotation = ((rotation % 360) + 360) % 360;
        const centerIndex = Math.round(normalizedRotation / anglePerPiece) % puzzlePiecesData.length;

        // Pure style writes — no DOM reads inside this loop
        for (let index = 0; index < piecesElements.length; index++) {
            const angle = anglePerPiece * index - rotation;
            const radian = (angle * Math.PI) / 180;
            const x = Math.cos(radian) * radius;
            const y = Math.sin(radian) * radius;
            const isCentered = index === centerIndex;
            const el = piecesElements[index];
            el.style.transform = `translate(${x.toFixed(1)}px,${y.toFixed(1)}px) scale(${isCentered ? 1.3 : 1})`;
            el.style.zIndex = isCentered ? '50' : '10';
            el.style.opacity = isCentered ? '1' : '0.6';
        }

        // Only update mobile tooltip when centered piece changes — not every frame
        if (isMobile && centerIndex !== prevCenterIndex) {
            if (prevCenterIndex >= 0) tooltips[prevCenterIndex].style.opacity = '0';
            tooltips[centerIndex].style.opacity = '1';
            prevCenterIndex = centerIndex;
        }

        puzzleOrbitAnimation = requestAnimationFrame(animate);
    };

    if (puzzleOrbitAnimation) cancelAnimationFrame(puzzleOrbitAnimation);
    puzzleOrbitAnimation = requestAnimationFrame(animate);
}

function openPieceDetail(index) {
    currentSelectedPieceIndex = index;
    const modal = document.getElementById('piece-detail-modal');
    const content = document.getElementById('piece-detail-content');
    renderPieceDetail();

    modal.classList.remove('hidden');
    setTimeout(() => {
        content.classList.remove('scale-95', 'opacity-0');
        content.classList.add('scale-100', 'opacity-100');
    }, 10);
}

function closePieceDetail() {
    const modal = document.getElementById('piece-detail-modal');
    const content = document.getElementById('piece-detail-content');
    content.classList.remove('scale-100', 'opacity-100');
    content.classList.add('scale-95', 'opacity-0');

    setTimeout(() => {
        document.getElementById('piece-detail-body').innerHTML = '';
        modal.classList.add('hidden');
    }, 300);
}

function navigatePiece(dir) {
    if (dir === 'next') {
        currentSelectedPieceIndex = (currentSelectedPieceIndex + 1) % puzzlePiecesData.length;
    } else {
        currentSelectedPieceIndex = (currentSelectedPieceIndex - 1 + puzzlePiecesData.length) % puzzlePiecesData.length;
    }
    renderPieceDetail();
}

function renderPieceDetail() {
    const piece = puzzlePiecesData[currentSelectedPieceIndex];
    const body = document.getElementById('piece-detail-body');
    const origin = window.location.origin;

    body.innerHTML = `
        <div class="relative">
            <img src="${piece.image}" alt="${piece.theme}" onerror="this.src='https://cdn.shopify.com/s/files/1/0328/9032/3077/files/DSC0818_1.webp?v=1778499573'" class="w-full h-auto rounded-[16px] shadow-2xl">
        </div>
        <div>
            <div class="mb-[24px]">
                <span class="inline-block px-4 py-2 bg-yellow-500/20 border border-yellow-500/50 rounded-[9999px] text-yellow-400 text-[14px] mb-[16px]">
                    ${piece.month}
                </span>
                <h3 class="text-[30px] md:text-[48px] font-garamond text-white mb-[16px]">
                    ${piece.theme}
                </h3>
                <p class="text-gray-300 text-[18px] leading-relaxed">
                    ${piece.desc}
                </p>
            </div>
            <div class="relative w-full aspect-video rounded-[8px] overflow-hidden shadow-2xl">
                <iframe
                    src="https://www.youtube.com/embed/${piece.youtube}?origin=${origin}"
                    title="${piece.theme}"
                    style="border: 0;"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    class="w-full h-full"
                ></iframe>
            </div>
        </div>
    `;
}

const initSystemNotifications = () => {
    const container = document.getElementById('token-economy');
    if (!container) return;

    const innerContainer = container.querySelector('.max-w-6xl') || container;

    const messages = [
        { text: 'Vendor just got paid', icon: 'zap', color: 'bg-yellow-500' },
        { text: '+200 tokens earned', icon: 'coins', color: 'bg-green-500' },
        { text: 'New mural piece added', icon: 'puzzle', color: 'bg-blue-500' },
        { text: 'Community goal reached', icon: 'sparkles', color: 'bg-purple-500' },
        { text: 'Live session starting', icon: 'mic-2', color: 'bg-red-500' },
        { text: 'VibeLink active', icon: 'map-pin', color: 'bg-orange-500' }
    ];

    const mapArea = container.querySelector('.relative.h-\\[600px\\]') || innerContainer;
    let pillInterval = null;

    const spawnPill = () => {
        const msg = messages[Math.floor(Math.random() * messages.length)];
        const pill = document.createElement('div');
        pill.className = `absolute z-[60] px-4 py-2 ${msg.color} text-black rounded-[9999px] font-bold shadow-[0_0_20px_rgba(0,0,0,0.5)] flex items-center gap-[8px] pointer-events-none opacity-0 transition-all duration-1000 transform translate-y-4 border border-white/20`;
        pill.innerHTML = `
            <i data-lucide="${msg.icon}" class="w-[16px] h-[16px]"></i>
            <span class="text-[12px] md:text-[14px] font-bold whitespace-nowrap uppercase tracking-wider">${msg.text}</span>
        `;

        // Position within the SVG area
        const x = 10 + Math.random() * 80;
        const y = 20 + Math.random() * 60;
        pill.style.left = `${x}%`;
        pill.style.top = `${y}%`;

        mapArea.appendChild(pill);
        if (typeof lucide !== 'undefined') lucide.createIcons({ root: pill });

        setTimeout(() => {
            pill.classList.remove('opacity-0', 'translate-y-4');
            pill.classList.add('opacity-100', 'translate-y-0');
        }, 100);

        setTimeout(() => {
            pill.style.transform = 'translateY(-40px)';
            pill.style.opacity = '0';
            setTimeout(() => pill.remove(), 1000);
        }, 4000);
    };

    const startPills = () => {
        if (pillInterval) return;
        pillInterval = setInterval(spawnPill, 5000);
    };

    const stopPills = () => {
        if (pillInterval) {
            clearInterval(pillInterval);
            pillInterval = null;
        }
    };

    container._startAutoplay = startPills;
    container._stopAutoplay = stopPills;

    // Initial trigger: defer start
    setTimeout(startPills, 2000);
};

const initCountdown = () => {
    const countdownEl = document.getElementById('countdown');
    if (!countdownEl) return;

    let time = 45 * 60; // 45 minutes in seconds

    const updateTimer = () => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        countdownEl.innerText = `${minutes}:${seconds.toString().padStart(2, '0')}`;

        if (time > 0) {
            time--;
        } else {
            clearInterval(timerInterval);
            countdownEl.classList.add('text-red-600', 'animate-bounce');
            countdownEl.innerText = "0:00";
        }
    };

    const timerInterval = setInterval(updateTimer, 1000);
    updateTimer(); // Initial call
};

let economyStep = 0;
let economyTokens = 0;
const totalEconomySteps = 5;

window.handleAnswerPrompt = () => {
    const btn = document.getElementById('answer-btn');
    const answer = document.getElementById('prompt-answer');

    if (btn.disabled) return;

    btn.disabled = true;
    btn.innerText = 'Answering...';
    answer.classList.remove('opacity-0');

    setTimeout(() => {
        economyTokens = 20;
        showEconomyFeedback('+20 Tokens');

        setTimeout(() => {
            nextSimStep();
        }, 1500);
    }, 1500);
};

window.handleRewardSelect = (reward, cost) => {
    if (economyTokens < cost) return;

    economyTokens -= cost;
    document.getElementById('selected-reward-name').innerText = reward;
    showEconomyFeedback(`Unlocked: ${reward}`);

    setTimeout(() => {
        nextSimStep();
    }, 1500);
};

window.nextSimStep = () => {
    economyStep = (economyStep + 1) % totalEconomySteps;
    updateSimUI();
};

window.resetSim = () => {
    economyStep = 0;
    economyTokens = 0;

    // Reset step 0 state
    const btn = document.getElementById('answer-btn');
    const answer = document.getElementById('prompt-answer');
    btn.disabled = false;
    btn.innerText = 'Answer Prompt';
    answer.classList.add('opacity-0');

    updateSimUI();
};

const showEconomyFeedback = (text) => {
    const feedback = document.getElementById('economy-feedback');
    feedback.innerText = text;
    feedback.classList.remove('opacity-0', '-translate-y-4');
    feedback.classList.add('opacity-1', 'translate-y-0');

    setTimeout(() => {
        feedback.classList.add('opacity-0', '-translate-y-4');
        feedback.classList.remove('opacity-1', 'translate-y-0');
    }, 2000);
};

const updateSimUI = () => {
    // Update Indicators
    const indicators = document.querySelectorAll('#economy-steps-indicator .sim-step');
    indicators.forEach((ind, idx) => {
        ind.classList.remove('active', 'completed', 'w-[48px]', 'w-[8px]');
        if (idx < economyStep) {
            ind.classList.add('completed', 'w-[48px]');
        } else if (idx === economyStep) {
            ind.classList.add('active', 'w-[48px]');
        } else {
            ind.classList.add('w-[8px]');
        }
    });

    // Update Content
    const contents = document.querySelectorAll('#economy-sim-area .sim-step-content');
    contents.forEach((content, idx) => {
        if (idx === economyStep) {
            content.classList.remove('hidden');
        } else {
            content.classList.add('hidden');
        }
    });

    // Update displays
    const tokenCount = document.getElementById('sim-token-count');
    if (tokenCount) tokenCount.innerText = economyTokens;

    const displayTokens = document.getElementById('current-tokens-display');
    if (displayTokens) displayTokens.innerText = economyTokens;

    // Update merch button status
    const merchBtn = document.getElementById('merch-btn');
    if (merchBtn) {
        if (economyTokens >= 25) {
            merchBtn.classList.remove('opacity-50', 'cursor-not-allowed');
            merchBtn.disabled = false;
        } else {
            merchBtn.classList.add('opacity-50', 'cursor-not-allowed');
            merchBtn.disabled = true;
        }
    }

    // Re-initialize icons
    if (window.lucide) {
        const simArea = document.getElementById('economy-sim-area');
        lucide.createIcons({ root: simArea || document.body });
    }
};


const initAddonCarousel = () => {
    const carousel = document.getElementById('addon-carousel');
    const dotsContainer = document.getElementById('addon-dots');
    if (!carousel) return;

    let isDragging = false;
    let startX;
    let scrollLeft;
    let currentStep = 0;

    const updateDots = () => {
        const dots = dotsContainer.querySelectorAll('button');
        dots.forEach((dot, i) => {
            if (i === currentStep) {
                dot.classList.add('bg-blue-500', 'w-[32px]');
                dot.classList.remove('bg-white/30', 'w-[8px]');
            } else {
                dot.classList.remove('bg-blue-500', 'w-[32px]');
                dot.classList.add('bg-white/30', 'w-[8px]');
            }
        });
    };

    const handleScroll = () => {
        const width = carousel.querySelector('div').offsetWidth + 24; // width + gap
        currentStep = Math.round(carousel.scrollLeft / width);
        updateDots();
    };

    carousel.addEventListener('scroll', handleScroll);

    // Mouse events
    carousel.addEventListener('mousedown', (e) => {
        isDragging = true;
        carousel.classList.add('active');
        startX = e.pageX - carousel.offsetLeft;
        scrollLeft = carousel.scrollLeft;
    });

    carousel.addEventListener('mouseleave', () => {
        isDragging = false;
        carousel.classList.remove('active');
    });

    carousel.addEventListener('mouseup', () => {
        isDragging = false;
        carousel.classList.remove('active');
    });

    carousel.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - carousel.offsetLeft;
        const walk = (x - startX) * 2;
        carousel.scrollLeft = scrollLeft - walk;
    });

    // Mobile Dots Click
    if (dotsContainer) {
        const dots = dotsContainer.querySelectorAll('button');
        dots.forEach((dot, i) => {
            dot.addEventListener('click', () => {
                const width = carousel.querySelector('div').offsetWidth + 24;
                carousel.scrollTo({
                    left: i * width,
                    behavior: 'smooth'
                });
            });
        });
    }
};

const finalizeSystemMap = () => {
    // Reveal system
    initReveals();

    // Interactions
    initInteractions();

    // Data stream systems
    initDataStream();

    // Addon Carousel
    initAddonCarousel();

    // Video Slider
    initVideoSlider();

    // Card Glow
    initCardGlow();

    // Dynamic Prompt Slider
    initDynamicPromptSlider();

    // System Map
    initSystemMap();

    // Artifact Portal
    initArtifactPortal();

    // Puzzle Orbit
    initPuzzleOrbit();

    // System Notifications
    initSystemNotifications();

    // Countdown Timer
    initCountdown();

    // About Section
    initAboutSection();

    // Action Carousel
    initActionCarousel();

    const mapArea = document.querySelector('#token-economy .reveal');
    if (mapArea) {
        setTimeout(() => {
            mapArea.classList.add('active');
        }, 1000);
    }

    // Height Equalization
    setTimeout(() => {
        if (typeof equalizeVideoHeights === 'function') equalizeVideoHeights();
        if (typeof equalizeArtifactHeights === 'function') equalizeArtifactHeights();
    }, 500);

    if (typeof lucide !== 'undefined') {
        lucide.createIcons();
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', finalizeSystemMap);
} else {
    finalizeSystemMap();
}

const equalizeVideoHeights = () => {
    const s = document.getElementById("video-slider");
    if (s) {
        const cards = s.querySelectorAll(".snap-center");
        let max = 0;
        cards.forEach(c => {
            c.style.height = "auto";
            if (c.offsetHeight > max) max = c.offsetHeight;
        });
        cards.forEach(c => c.style.height = max + "px");
    }
};

window.addEventListener("resize", equalizeVideoHeights);
window.addEventListener("load", equalizeVideoHeights);
setTimeout(equalizeVideoHeights, 2000);





// About Section Logic
let aboutImageIndex = 0;


function initAboutSection() {
    const container = document.getElementById('carey-image-container');
    if (!container) return;

    // Initial image
    updateAboutImage();

    // Rotate every 5 seconds
    setInterval(() => {
        aboutImageIndex = (aboutImageIndex + 1) % aboutImages.length;
        updateAboutImage();
    }, 5000);
}

function updateAboutImage() {
    const container = document.getElementById('carey-image-container');
    if (!container) return;

    // Create new image element
    const img = document.createElement('img');
    img.src = aboutImages[aboutImageIndex];
    img.alt = "Carey Fountain";
    img.className = "absolute inset-0 w-full h-full object-cover object-top transition-opacity duration-1000 opacity-0";

    // Fade in
    container.appendChild(img);
    setTimeout(() => {
        img.classList.remove('opacity-0');
        img.classList.add('opacity-100');
    }, 10);

    // Remove old images
    const oldImages = container.querySelectorAll('img');
    if (oldImages.length > 1) {
        const oldImg = oldImages[0];
        oldImg.classList.remove('opacity-100');
        oldImg.classList.add('opacity-0');
        setTimeout(() => oldImg.remove(), 1000);
    }
}

window.toggleBio = () => {
    const bio = document.getElementById('about-bio-expanded');
    const btnText = document.getElementById('toggle-bio-text');
    const btnIcon = document.getElementById('toggle-bio-icon');

    if (!bio || !btnText || !btnIcon) return;

    const isExpanded = bio.classList.contains('max-h-[500px]');

    if (isExpanded) {
        bio.classList.remove('max-h-[500px]', 'opacity-100');
        bio.classList.add('max-h-0', 'opacity-0');
        btnText.textContent = "Read more";
        btnIcon.classList.remove('rotate-180');
    } else {
        bio.classList.remove('max-h-0', 'opacity-0');
        bio.classList.add('max-h-[500px]', 'opacity-100');
        btnText.textContent = "Read less";
        btnIcon.classList.add('rotate-180');
    }
};

// Wildcard In Action Carousel Logic
let currentActionSlide = 0;
let actionInterval;
let actionSlideElements = [];


function initActionCarousel() {
    const container = document.getElementById('action-carousel-container');
    const pagination = document.getElementById('action-pagination');
    if (!container || !pagination) return;

    container.innerHTML = '';
    pagination.innerHTML = '';
    actionSlideElements = [];

    // Create Slides once
    actionImages.forEach((src, idx) => {
        // Create Dot
        const dot = document.createElement('button');
        dot.className = `action-dot relative w-[12px] h-[12px] rounded-[9999px] transition-all duration-300 bg-white/40 hover:bg-white/60`;
        dot.setAttribute('data-index', idx);
        dot.onclick = () => {
            goToActionSlide(idx);
        };
        pagination.appendChild(dot);

        // Create Slide
        const slide = document.createElement('div');
        slide.className = `action-slide absolute cursor-pointer transition-all duration-1000 ease-[cubic-bezier(0.32,0.72,0,1)] opacity-0 pointer-events-none`;
        slide.style.transformStyle = 'preserve-3d';
        slide.style.zIndex = 0;

        const content = document.createElement('div');
        content.className = `action-content relative w-[280px] md:w-[450px] lg:w-[600px] h-[400px] md:h-[500px] lg:h-[600px] rounded-[16px] overflow-hidden shadow-2xl transition-all duration-500`;

        content.innerHTML = `
            <img src="${src}" alt="Wildcard activation" class="w-full h-full object-cover">
            <div class="action-overlay absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent transition-opacity duration-500"></div>
            <div class="action-footer absolute bottom-8 left-8 right-8 text-center opacity-0 transition-opacity duration-500">
                <div class="w-full h-1 bg-white/20 rounded-[9999px] overflow-hidden mb-[16px]">
                    <div class="action-progress h-full bg-red-500 w-0"></div>
                </div>
                <p class="text-white text-[18px] font-garamond italic">"Moment from Wildcard"</p>
            </div>
        `;

        slide.onclick = () => {
            if (idx === currentActionSlide) {
                openLightbox(src);
            } else {
                goToActionSlide(idx);
            }
        };

        slide.appendChild(content);
        container.appendChild(slide);
        actionSlideElements.push(slide);
    });

    updateActionCarousel();
    startActionTimer();
}

function startActionTimer() {
    if (actionInterval) clearInterval(actionInterval);
    actionInterval = setInterval(() => {
        nextActionSlide();
    }, 4000);
}

function goToActionSlide(idx) {
    currentActionSlide = idx;
    updateActionCarousel();
    startActionTimer();
}

function updateActionCarousel() {
    const dots = document.querySelectorAll('.action-dot');

    actionSlideElements.forEach((slide, idx) => {
        const offset = idx - currentActionSlide;
        const isActive = idx === currentActionSlide;

        // Handle circular wrap-around
        let isPrev = offset === -1 || (currentActionSlide === 0 && idx === actionImages.length - 1);
        let isNext = offset === 1 || (currentActionSlide === actionImages.length - 1 && idx === 0);

        const isVisible = isActive || isPrev || isNext;

        // Reset slide state
        slide.classList.remove('pointer-events-none');
        const content = slide.querySelector('.action-content');
        const overlay = slide.querySelector('.action-overlay');
        const footer = slide.querySelector('.action-footer');
        const progress = slide.querySelector('.action-progress');

        if (isVisible) {
            slide.style.opacity = isActive ? '1' : '0.4';
            slide.style.zIndex = isActive ? '100' : '50';

            const isMobile = window.innerWidth < 768;
            let x = '0';
            let scale = isActive ? '1' : (isMobile ? 0.6 : 0.75);
            let rotateY = '0';

            if (isPrev) {
                x = isMobile ? '-70%' : '-85%';
                rotateY = isMobile ? '15deg' : '25deg';
            } else if (isNext) {
                x = isMobile ? '70%' : '85%';
                rotateY = isMobile ? '-15deg' : '-25deg';
            }

            slide.style.transform = `translateX(${x}) scale(${scale}) translateZ(${isActive ? '100px' : '0px'}) rotateY(${rotateY})`;

            // Active slide specific styles
            if (isActive) {
                content.style.boxShadow = '0 0 40px rgba(239, 68, 68, 0.3)';
                content.classList.add('hover:scale-[1.02]');
                overlay.style.opacity = '0.3';
                footer.style.opacity = '1';

                // Progress bar animation
                progress.style.transition = 'none';
                progress.style.width = '0%';
                setTimeout(() => {
                    progress.style.transition = 'width 4000ms linear';
                    progress.style.width = '100%';
                }, 50);
            } else {
                content.style.boxShadow = 'none';
                content.classList.remove('hover:scale-[1.02]');
                overlay.style.opacity = '0.8';
                footer.style.opacity = '0';
                progress.style.width = '0%';
            }
        } else {
            slide.style.opacity = '0';
            slide.style.zIndex = '0';
            slide.style.transform = `translateX(${offset > 0 ? '150%' : '-150%'}) scale(0.5)`;
            slide.classList.add('pointer-events-none');
        }
    });

    // Update Dots
    dots.forEach((dot, idx) => {
        const isActive = idx === currentActionSlide;
        dot.className = `action-dot relative w-[12px] h-[12px] rounded-[9999px] transition-all duration-300 ${isActive ? 'bg-red-500 scale-125' : 'bg-white/40 hover:bg-white/60'}`;

        // Pulse effect
        let pulse = dot.querySelector('.dot-pulse');
        if (isActive) {
            if (!pulse) {
                pulse = document.createElement('div');
                pulse.className = "dot-pulse absolute inset-0 rounded-[9999px] border-2 border-red-500 animate-[ping_1s_infinite]";
                dot.appendChild(pulse);
            }
        } else if (pulse) {
            pulse.remove();
        }
    });
}

window.prevActionSlide = () => {
    currentActionSlide = (currentActionSlide - 1 + actionImages.length) % actionImages.length;
    updateActionCarousel();
    startActionTimer();
};

window.nextActionSlide = () => {
    currentActionSlide = (currentActionSlide + 1) % actionImages.length;
    updateActionCarousel();
    startActionTimer();
};

// Lightbox Logic
window.openLightbox = (src) => {
    const lightbox = document.getElementById('lightbox');
    const img = document.getElementById('lightbox-img');
    if (!lightbox || !img) return;

    img.src = src;
    lightbox.classList.remove('hidden');
    lightbox.classList.add('flex');
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
        lightbox.classList.remove('opacity-0');
        lightbox.classList.add('opacity-100');
    }, 10);
};

window.closeLightbox = () => {
    const lightbox = document.getElementById('lightbox');
    const img = document.getElementById('lightbox-img');
    if (!lightbox) return;

    lightbox.classList.remove('opacity-100');
    lightbox.classList.add('opacity-0');
    document.body.style.overflow = '';

    setTimeout(() => {
        lightbox.classList.add('hidden');
        lightbox.classList.remove('flex');
        if (img) img.src = ''; // FREE UP LARGE BITMAP MEMORY
    }, 500);
};

// Partnership Selector & Multi-Step Form Logic
const partnershipOptions = [
    {
        flow: 'host',
        icon: 'building-2',
        title: 'Host Wildcard',
        description: 'Bring the full experience to your venue or space',
        color: 'from-red-500/20 to-orange-500/20',
        borderColor: 'border-red-500/50',
        iconColor: 'text-red-400',
    },
    {
        flow: 'sponsor',
        icon: 'dollar-sign',
        title: 'Sponsor the Experience',
        description: 'Support Wildcard and engage with our community',
        color: 'from-yellow-500/20 to-orange-500/20',
        borderColor: 'border-yellow-500/50',
        iconColor: 'text-yellow-400',
    },
    {
        flow: 'vibelink',
        icon: 'map-pin',
        title: 'Join VibeLink',
        description: 'Integrate the QR token system into your restaurant or bar',
        color: 'from-purple-500/20 to-pink-500/20',
        borderColor: 'border-purple-500/50',
        iconColor: 'text-purple-400',
    },
    {
        flow: 'live-experience',
        icon: 'music',
        title: 'Present Live Music',
        description: 'Bring live music integration to Wildcard events',
        color: 'from-blue-500/20 to-cyan-500/20',
        borderColor: 'border-blue-500/50',
        iconColor: 'text-blue-400',
    },
    {
        flow: 'vendor',
        icon: 'shopping-bag',
        title: 'Become a Vendor',
        description: 'Offer products or services redeemable with Vibe Tokens',
        color: 'from-green-500/20 to-emerald-500/20',
        borderColor: 'border-green-500/50',
        iconColor: 'text-green-400',
    },
];

const formFlows = {
    host: {
        title: 'Host Wildcard',
        subtitle: 'Tell us about your space',
        questions: [
            { id: 'firstName', question: "What's your first name?", type: 'input', placeholder: 'First name', required: true },
            { id: 'lastName', question: "What's your last name?", type: 'input', placeholder: 'Last name', required: true },
            { id: 'email', question: "What's your email address?", type: 'input', placeholder: 'email@example.com', required: true },
            { id: 'venueName', question: "What's the name of your venue?", type: 'input', placeholder: 'Venue name', required: true },
            { id: 'location', question: 'Where are you located?', type: 'input', placeholder: 'City, State', required: true },
            { id: 'venueType', question: 'What type of venue is this?', type: 'buttons', options: ['Gallery', 'Museum', 'Lounge/Bar', 'University', 'Community Space', 'Creative District', 'Other'], required: true },
            { id: 'audienceSize', question: "What's your typical audience size?", type: 'buttons', options: ['Under 50', '50-100', '100-200', '200+'], required: true },
            { id: 'spaceType', question: 'Indoor or outdoor?', type: 'buttons', options: ['Indoor', 'Outdoor', 'Both'], required: true },
            { id: 'foodDrink', question: 'Do you have food & drink available?', type: 'buttons', options: ['Yes', 'No', 'Can arrange'], required: true },
            { id: 'experienceInterest', question: 'Which experiences interest you most?', type: 'buttons', options: ['Core Experience', 'Live Music Integration', 'VibeLink QR System', 'Full Ecosystem'], required: true },
            { id: 'timeline', question: "What's your timeline?", type: 'buttons', options: ['Next month', '2-3 months', '3-6 months', 'Exploring'], required: true },
            { id: 'budget', question: "What's your budget range?", type: 'buttons', options: ['$1.5K-$3K', '$3K-$5K', '$5K+', 'Need to discuss'], required: true },
        ]
    },
    sponsor: {
        title: 'Sponsor Wildcard',
        subtitle: 'Partner with us',
        questions: [
            { id: 'firstName', question: "What's your first name?", type: 'input', placeholder: 'First name', required: true },
            { id: 'lastName', question: "What's your last name?", type: 'input', placeholder: 'Last name', required: true },
            { id: 'email', question: "What's your email address?", type: 'input', placeholder: 'email@example.com', required: true },
            { id: 'brandName', question: "What's your brand or organization name?", type: 'input', placeholder: 'Brand name', required: true },
            { id: 'industry', question: 'What industry are you in?', type: 'buttons', options: ['Tech', 'Arts & Culture', 'Food & Beverage', 'Lifestyle', 'Education', 'Other'], required: true },
            { id: 'goals', question: 'What are your sponsorship goals?', type: 'buttons', options: ['Brand awareness', 'Community engagement', 'Cultural impact', 'Product activation', 'All of the above'], required: true },
            { id: 'budget', question: "What's your budget range?", type: 'buttons', options: ['$5K-$10K', '$10K-$25K', '$25K+', 'Need to discuss'], required: true },
            { id: 'cities', question: 'Which cities interest you?', type: 'input', placeholder: 'City names (comma separated)', required: true },
        ]
    },
    vibelink: {
        title: 'Join VibeLink',
        subtitle: 'Bring the token economy to your venue',
        questions: [
            { id: 'firstName', question: "What's your first name?", type: 'input', placeholder: 'First name', required: true },
            { id: 'lastName', question: "What's your last name?", type: 'input', placeholder: 'Last name', required: true },
            { id: 'email', question: "What's your email address?", type: 'input', placeholder: 'email@example.com', required: true },
            { id: 'venueName', question: "What's your venue name?", type: 'input', placeholder: 'Venue name', required: true },
            { id: 'venueType', question: 'What type of venue?', type: 'buttons', options: ['Restaurant', 'Bar', 'Lounge', 'Cafe', 'Other'], required: true },
            { id: 'tableCount', question: 'How many tables do you have?', type: 'buttons', options: ['Under 10', '10-20', '20-30', '30+'], required: true },
            { id: 'goals', question: 'What are your goals?', type: 'buttons', options: ['Increase table time', 'Boost revenue', 'Create social buzz', 'All of the above'], required: true },
            { id: 'pilotInterest', question: 'Interest in a pilot program?', type: 'buttons', options: ['Very interested', 'Somewhat interested', 'Just exploring'], required: true },
            { id: 'location', question: 'Where are you located?', type: 'input', placeholder: 'City, State', required: true },
        ]
    },
    'live-experience': {
        title: 'Present Live Music',
        subtitle: 'Integrate your sound',
        questions: [
            { id: 'firstName', question: "What's your first name?", type: 'input', placeholder: 'First name', required: true },
            { id: 'lastName', question: "What's your last name?", type: 'input', placeholder: 'Last name', required: true },
            { id: 'email', question: "What's your email address?", type: 'input', placeholder: 'email@example.com', required: true },
            { id: 'venueName', question: 'Venue or event name?', type: 'input', placeholder: 'Name', required: true },
            { id: 'eventType', question: 'What type of event?', type: 'buttons', options: ['Venue series', 'One-off event', 'Festival', 'Private event', 'Other'], required: true },
            { id: 'vibe', question: 'What vibe are you going for?', type: 'buttons', options: ['Jazz/Soul', 'Electronic', 'Hip-Hop', 'Experimental', 'Mixed', 'Other'], required: true },
            { id: 'budget', question: "What's your budget range?", type: 'buttons', options: ['$1K-$3K', '$3K-$5K', '$5K+', 'Need to discuss'], required: true },
            { id: 'location', question: 'Where are you located?', type: 'input', placeholder: 'City, State', required: true },
        ]
    },
    vendor: {
        title: 'Become a Vendor',
        subtitle: 'Join the token ecosystem',
        questions: [
            { id: 'firstName', question: "What's your first name?", type: 'input', placeholder: 'First name', required: true },
            { id: 'lastName', question: "What's your last name?", type: 'input', placeholder: 'Last name', required: true },
            { id: 'email', question: "What's your email address?", type: 'input', placeholder: 'email@example.com', required: true },
            { id: 'businessName', question: "What's your business name?", type: 'input', placeholder: 'Business name', required: true },
            { id: 'category', question: 'What category are you in?', type: 'buttons', options: ['Food & Beverage', 'Art & Merch', 'Services', 'Experiences', 'Other'], required: true },
            { id: 'offerings', question: 'What do you offer?', type: 'textarea', placeholder: 'Describe your products or services', required: true },
            { id: 'priceRange', question: "What's your typical price range?", type: 'buttons', options: ['$5-$15', '$15-$30', '$30-$50', '$50+'], required: true },
            { id: 'location', question: 'Where are you based?', type: 'input', placeholder: 'City, State', required: true },
            { id: 'tokenInterest', question: 'Interest in token redemption?', type: 'buttons', options: ['Very interested', 'Interested', 'Want to learn more'], required: true },
        ]
    }
};

let currentFormFlow = null;
let currentFormStep = 0;
let formAnswers = {};

window.openPartnershipSelector = (source = 'Direct') => {
    formSource = source;
    const modal = document.getElementById('partnership-modal');
    const content = document.getElementById('partnership-modal-content');
    const grid = document.getElementById('partnership-options-grid');
    if (!modal || !content || !grid) return;

    // Render Options
    grid.innerHTML = partnershipOptions.map((opt, idx) => `
        <button onclick="startFormFlow('${opt.flow}')" 
            style="transition-delay: ${idx * 100}ms"
            class="bg-gradient-to-br ${opt.color} backdrop-blur-md border-2 ${opt.borderColor} p-[24px] rounded-[16px] text-left transition-all duration-300 hover:shadow-2xl group relative overflow-hidden reveal">
            <div class="absolute inset-0 bg-gradient-to-br from-white/0 to-white/5 rounded-[16px] opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"></div>
            <div class="relative">
                <i data-lucide="${opt.icon}" class="w-[48px] h-[48px] md:w-14 md:h-14 mb-[16px] ${opt.iconColor} group-hover:scale-110 transition-transform"></i>
                <h3 class="font-garamond text-[20px] md:text-[24px] text-white mb-[8px]">${opt.title}</h3>
                <p class="text-gray-300 text-[14px] md:text-[16px] mb-[16px] leading-relaxed">${opt.description}</p>
                <div class="inline-flex items-center gap-[8px] ${opt.iconColor} group-hover:gap-[12px] transition-all">
                    <span class="text-[14px] font-medium">Get Started</span>
                    <i data-lucide="chevron-right" class="w-[16px] h-[16px]"></i>
                </div>
            </div>
        </button>
    `).join('');

    if (typeof lucide !== 'undefined') lucide.createIcons();

    // Show modal
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
        content.classList.remove('scale-95', 'opacity-0');
        content.classList.add('scale-100', 'opacity-100');

        // Trigger reveal animations for the options
        grid.querySelectorAll('.reveal').forEach(el => el.classList.add('active'));
    }, 10);
};

window.closePartnershipSelector = () => {
    const modal = document.getElementById('partnership-modal');
    const content = document.getElementById('partnership-modal-content');
    if (!modal || !content) return;

    content.classList.remove('scale-100', 'opacity-100');
    content.classList.add('scale-95', 'opacity-0');

    setTimeout(() => {
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        document.body.style.overflow = '';
    }, 300);
};

window.startFormFlow = (flow) => {
    closeRoleModal();
    closePartnershipSelector();
    currentFormFlow = flow;
    currentFormStep = 0;
    formAnswers = {};

    setTimeout(() => {
        openMultiStepForm();
    }, 400);
};

window.openMultiStepForm = () => {
    const modal = document.getElementById('form-modal');
    const content = document.getElementById('form-modal-content');
    if (!modal || !content) return;

    renderFormStep();

    modal.classList.remove('hidden');
    modal.classList.add('flex');
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
        content.classList.remove('scale-95', 'opacity-0');
        content.classList.add('scale-100', 'opacity-100');
    }, 10);
};

window.closeMultiStepForm = () => {
    const modal = document.getElementById('form-modal');
    const content = document.getElementById('form-modal-content');
    if (!modal || !content) return;

    content.classList.remove('scale-100', 'opacity-100');
    content.classList.add('scale-95', 'opacity-0');

    setTimeout(() => {
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        document.body.style.overflow = '';
    }, 300);
};

function renderFormStep() {
    const inner = document.getElementById('form-inner-content');
    const config = formFlows[currentFormFlow];
    if (!inner || !config) return;

    const question = config.questions[currentFormStep];
    const totalSteps = config.questions.length;

    let html = `
        <!-- Header -->
        <div class="text-center mb-[32px]">
            <h2 class="font-garamond text-[30px] md:text-[36px] mb-[8px] text-white animate-[fadeInDown_0.5s_ease-out]">${config.title}</h2>
            <p class="text-gray-400 text-[14px] animate-[fadeIn_0.5s_ease-out_0.2s_forwards] opacity-0">${config.subtitle} · This takes less than 60 seconds</p>
        </div>

        <!-- Progress Indicator -->
        <div class="flex justify-center gap-[8px] mb-[4px]0">
            ${Array.from({ length: totalSteps }).map((_, idx) => `
                <div class="h-2 rounded-[9999px] transition-all duration-300 ${idx === currentFormStep ? 'w-[48px] bg-yellow-400 shadow-lg shadow-yellow-400/50' :
            idx < currentFormStep ? 'w-[32px] bg-green-400' : 'w-2 bg-gray-600'
        }"></div>
            `).join('')}
        </div>

        <!-- Question Area -->
        <div class="min-h-[300px] flex flex-col justify-between animate-[fadeInRight_0.5s_ease-out]">
            <div>
                <h3 class="font-garamond text-[24px] md:text-[30px] text-white mb-[32px] text-center leading-relaxed">${question.question}</h3>
                
                ${renderQuestionInput(question)}
            </div>

            <!-- Navigation -->
            <div class="flex gap-[12px] mt-8">
                ${currentFormStep > 0 ? `
                    <button onclick="prevFormStep()" class="px-6 py-4 bg-white/10 border border-white/20 text-white rounded-[12px] flex items-center gap-[8px] hover:bg-white/20 transition-all">
                        <i data-lucide="chevron-left" class="w-[20px] h-[20px]"></i>
                        Back
                    </button>
                ` : ''}
                ${question.type !== 'buttons' ? `
                    <button id="form-next-btn" onclick="nextFormStep()" class="flex-1 px-8 py-4 bg-gradient-to-r from-yellow-500 to-orange-500 text-black rounded-[12px] font-semibold text-[18px] hover:from-yellow-400 hover:to-orange-400 shadow-lg transition-all flex items-center justify-center gap-[8px]">
                        ${currentFormStep === totalSteps - 1 ? 'Submit' : 'Continue'}
                        <i data-lucide="chevron-right" class="w-[20px] h-[20px]"></i>
                    </button>
                ` : ''}
            </div>
        </div>
    `;

    inner.innerHTML = html;
    if (typeof lucide !== 'undefined') lucide.createIcons();
}

function renderQuestionInput(question) {
    const value = formAnswers[question.id] || '';

    if (question.type === 'input') {
        return `<input type="text" value="${value}" oninput="saveAnswer('${question.id}', this.value)" placeholder="${question.placeholder}" class="w-full bg-white/5 backdrop-blur-sm border-2 border-white/20 rounded-[12px] p-[20px] text-white text-[18px] focus:outline-none focus:border-yellow-500 transition-colors" autofocus>`;
    }

    if (question.type === 'textarea') {
        return `<textarea oninput="saveAnswer('${question.id}', this.value)" placeholder="${question.placeholder}" class="w-full bg-white/5 backdrop-blur-sm border-2 border-white/20 rounded-[12px] p-[20px] text-white text-[18px] focus:outline-none focus:border-yellow-500 transition-colors h-32 resize-none" autofocus>${value}</textarea>`;
    }

    if (question.type === 'buttons') {
        return `
            <div class="grid grid-cols-1 md:grid-cols-2 gap-[12px]">
                ${question.options.map(opt => `
                    <button onclick="handleButtonAnswer('${question.id}', '${opt}')" 
                        class="p-[16px] rounded-[12px] border-2 transition-all text-left ${formAnswers[question.id] === opt ? 'bg-gradient-to-br from-yellow-500/30 to-orange-500/30 border-yellow-500 text-white shadow-lg shadow-yellow-500/20' :
                'bg-white/5 border-white/20 text-gray-300 hover:border-white/40'
            }">
                        ${opt}
                    </button>
                `).join('')}
            </div>
        `;
    }

    return '';
}

window.saveAnswer = (id, val) => {
    formAnswers[id] = val;
};

window.handleButtonAnswer = (id, val) => {
    formAnswers[id] = val;
    renderFormStep();
    setTimeout(() => {
        nextFormStep();
    }, 300);
};

window.nextFormStep = () => {
    const config = formFlows[currentFormFlow];
    const question = config.questions[currentFormStep];
    const answer = formAnswers[question.id];

    // Validation
    if (question.required && (!answer || (typeof answer === 'string' && answer.trim() === ''))) {
        const input = document.querySelector('input, textarea');
        if (input) {
            input.classList.add('border-red-500', 'animate-shake');
            setTimeout(() => input.classList.remove('animate-shake'), 500);
        }
        return;
    }

    if (currentFormStep < config.questions.length - 1) {
        currentFormStep++;
        renderFormStep();
    } else {
        renderSubmitScreen();
    }
};

window.prevFormStep = () => {
    if (currentFormStep > 0) {
        currentFormStep--;
        renderFormStep();
    }
};

function renderSubmitScreen() {
    const inner = document.getElementById('form-inner-content');
    if (!inner) return;

    // Fill hidden Mailchimp form
    const mcForm = document.getElementById('mc-embedded-subscribe-form');
    if (mcForm) {
        document.getElementById('mce-EMAIL').value = formAnswers.email || '';
        document.getElementById('mce-FNAME').value = formAnswers.firstName || '';
        document.getElementById('mce-LNAME').value = formAnswers.lastName || '';
        document.getElementById('mce-ROLE').value = currentFormFlow || '';

        // Form Source Mapping for Mailchimp
        const flowTitles = {
            'host': 'Host Wildcard',
            'sponsor': 'Sponsor Wildcard',
            'vibelink': 'Join VibeLink',
            'live-experience': 'Present Live Music',
            'vendor': 'Become a Vendor'
        };
        const niceTitle = flowTitles[currentFormFlow] || 'Wildcard Partner';
        document.getElementById('mce-MMERGE3').value = `${niceTitle} | ${formSource}`;

        // Dynamic Mapping
        document.getElementById('mce-ENTITY').value = formAnswers.venueName || formAnswers.brandName || formAnswers.businessName || '';
        document.getElementById('mce-LOCATION').value = formAnswers.location || formAnswers.cities || '';
        document.getElementById('mce-ENTITYTYPE').value = formAnswers.venueType || formAnswers.industry || formAnswers.eventType || formAnswers.category || '';
        document.getElementById('mce-BUDGET').value = formAnswers.budget || '';
        document.getElementById('mce-GOALS').value = formAnswers.goals || formAnswers.experienceInterest || '';
        document.getElementById('mce-AUDIENCE').value = formAnswers.audienceSize || '';
        document.getElementById('mce-SPACE_TYPE').value = formAnswers.spaceType || '';
        document.getElementById('mce-AMENITIES').value = formAnswers.foodDrink || '';
        document.getElementById('mce-TIMELINE').value = formAnswers.timeline || '';
        document.getElementById('mce-TABLES').value = formAnswers.tableCount || '';
        document.getElementById('mce-INTERESLVL').value = formAnswers.pilotInterest || formAnswers.tokenInterest || '';
        document.getElementById('mce-VIBE').value = formAnswers.vibe || '';
        document.getElementById('mce-OFFERINGS').value = formAnswers.offerings || '';
        document.getElementById('mce-PRICERANGE').value = formAnswers.priceRange || '';

        // Submit form (Background)
        // Note: Using a hidden iframe or fetch to submit without redirecting if possible,
        // but since it's a standard MC form, we'll just submit it.
        // To avoid user leaving our site, we'll use target="_blank" (already in HTML)
        mcForm.submit();
    }

    inner.innerHTML = `
        <div class="text-center py-12 md:py-16 animate-[scaleIn_0.5s_ease-out]">
            <!-- Animated Loading Pulse -->
            <div class="relative w-32 h-32 mx-auto mb-[32px]">
                <div class="absolute inset-0 rounded-[9999px] bg-gradient-to-br from-yellow-500/40 via-purple-500/40 to-red-500/40 blur-lg animate-pulse"></div>
                <div class="absolute inset-0 flex items-center justify-center">
                    <i data-lucide="loader-2" class="w-[64px] h-[64px] text-yellow-400 animate-spin"></i>
                </div>
            </div>

            <h3 class="font-garamond text-[30px] md:text-[48px] text-white mb-[16px]">You're almost there.</h3>
            <p class="text-gray-300 text-[16px] md:text-[18px] max-w-[512px] mx-auto mb-[24px] leading-relaxed">
                Next, choose a time that works for you so we can talk through the best way to plug you into Wildcard.
            </p>

            <p class="text-yellow-400 text-[14px] mb-[32px] italic animate-pulse">
                Redirecting you to schedule your Wildcard Discovery Call...
            </p>

            <a href="https://calendly.com/blackcherrytreeproject/wildcard-discovery-call" 
                class="inline-flex items-center gap-[8px] px-8 py-4 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-400 hover:to-orange-400 text-black font-semibold rounded-[12px] shadow-lg transition-all hover:scale-105 active:scale-95">
                Schedule Your Discovery Call
                <i data-lucide="chevron-right" class="w-[20px] h-[20px]"></i>
            </a>
        </div>
    `;

    if (typeof lucide !== 'undefined') lucide.createIcons();

    // Auto redirect
    setTimeout(() => {
        window.location.href = 'https://calendly.com/blackcherrytreeproject/wildcard-discovery-call';
    }, 2500);
}

// Initialize Step Slider (Mobile)
function initStepSlider() {
    const slider = document.getElementById('walk-in-slider');
    const pagination = document.getElementById('walk-in-pagination');
    const prevBtn = document.getElementById('step-prev-btn');
    const nextBtn = document.getElementById('step-next-btn');

    if (!slider || !pagination) return;

    const cards = slider.querySelectorAll('.step-card');
    const totalSteps = cards.length;

    // Generate Dots
    pagination.innerHTML = '';
    for (let i = 0; i < totalSteps; i++) {
        const dot = document.createElement('div');
        const spans = document.createElement('span');
        dot.appendChild(spans);
        dot.className = `h-[4px] rounded-full transition-all duration-300 ${i === 0 ? 'w-[24px] bg-yellow-400' : 'w-[8px] bg-white/20'}`;
        dot.dataset.index = i;
        pagination.appendChild(dot);
    }

    const dots = pagination.querySelectorAll('div');

    const updateControls = () => {
        if (!cards[0]) return;
        const cardWidth = cards[0].offsetWidth + 16; // width + gap
        const activeIndex = Math.round(slider.scrollLeft / cardWidth);

        // Update Dots
        dots.forEach((dot, i) => {
            if (i === activeIndex) {
                dot.classList.remove('w-[8px]', 'bg-white/20');
                dot.classList.add('w-[24px]', 'bg-yellow-400');
            } else {
                dot.classList.remove('w-[24px]', 'bg-yellow-400');
                dot.classList.add('w-[8px]', 'bg-white/20');
            }
        });

        // Update Buttons
        if (prevBtn && nextBtn) {
            if (activeIndex === 0) {
                prevBtn.classList.add('opacity-0', 'pointer-events-none');
            } else {
                prevBtn.classList.remove('opacity-0', 'pointer-events-none');
            }

            if (activeIndex >= totalSteps - 1) {
                nextBtn.classList.add('opacity-0', 'pointer-events-none');
            } else {
                nextBtn.classList.remove('opacity-0', 'pointer-events-none');
            }
        }
    };

    slider.addEventListener('scroll', () => {
        requestAnimationFrame(updateControls);
    });

    window.scrollStepSlider = (direction) => {
        const cardWidth = cards[0].offsetWidth + 16;
        const targetScroll = direction === 'next'
            ? slider.scrollLeft + cardWidth
            : slider.scrollLeft - cardWidth;

        slider.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
        });
    };

    // Initial check
    setTimeout(updateControls, 100);
}

// Call init functions
document.addEventListener('DOMContentLoaded', () => {
    initStepSlider();
    initSpacesSlider();

    // Scroll to hash on page load if present in the URL
    const hash = window.location.hash.substring(1);

    if (hash) {

        // Walkthrough modal
        if ([
            'understand-wildcard',
            'understand',
            'walkthrough',
            'understand-in-60s',
            'understand-in-60-seconds'
        ].includes(hash.toLowerCase())) {

            setTimeout(() => {
                if (typeof window.showWalkthroughModal === 'function') {
                    window.showWalkthroughModal();
                }
            }, 400);

        }

  else if ([
    'floating-cta',
].includes(hash.toLowerCase()))  {

    setTimeout(() => {

        if (typeof openPartnershipSelector === 'function') {
            openPartnershipSelector('Floating CTA');
        }

    }, 400);
}

        // Get Involved popups
        else if ([
            'become-host',
            'become-sponsor',
            'join-vibelink',
            'become-vendor'
        ].includes(hash.toLowerCase())) {

            setTimeout(() => {

                const popupMap = {
                    'become-host': 'host',
                    'become-sponsor': 'sponsor',
                    'join-vibelink': 'vibelink',
                    'become-vendor': 'vendor'
                };

                const popupType = popupMap[hash.toLowerCase()];

                if (typeof window.openRoleModal === 'function') {
                    window.openRoleModal(popupType, 'Get Involved Section');
                }

                 const element = document.getElementById("partnership");

            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 400);
            }

            }, 400);

        }

        // Normal section scrolling
        else {

            const pathMap = {
                'attend': 'experience-selector',
                'host': 'host-section',
                'vendor': 'vendor-economy',
                'sponsor': 'partnership'
            };

            const sectionId = pathMap[hash] || hash;
            const element = document.getElementById(sectionId);

            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 400);
            }
        }
    }
});

// Initialize Spaces Slider (Mobile)
function initSpacesSlider() {
    const slider = document.getElementById('spaces-slider');
    const pagination = document.getElementById('spaces-pagination');
    const prevBtn = document.getElementById('spaces-prev-btn');
    const nextBtn = document.getElementById('spaces-next-btn');

    if (!slider || !pagination) return;

    const cards = slider.querySelectorAll('.relative.group');
    const totalSteps = cards.length;

    // Generate Dots
    pagination.innerHTML = '';
    for (let i = 0; i < totalSteps; i++) {
        const dot = document.createElement('div');
        dot.className = `h-[4px] rounded-full transition-all duration-300 ${i === 0 ? 'w-[24px] bg-white' : 'w-[8px] bg-white/20'}`;
        dot.dataset.index = i;
        pagination.appendChild(dot);
    }

    const dots = pagination.querySelectorAll('div');

    const updateControls = () => {
        if (!cards[0]) return;
        const cardWidth = cards[0].offsetWidth + 16; // width + gap
        const activeIndex = Math.round(slider.scrollLeft / cardWidth);

        // Update Dots
        dots.forEach((dot, i) => {
            if (i === activeIndex) {
                dot.classList.remove('w-[8px]', 'bg-white/20');
                dot.classList.add('w-[24px]', 'bg-white');
            } else {
                dot.classList.remove('w-[24px]', 'bg-white');
                dot.classList.add('w-[8px]', 'bg-white/20');
            }
        });

        // Update Buttons
        if (prevBtn && nextBtn) {
            if (activeIndex === 0) {
                prevBtn.classList.add('opacity-0', 'pointer-events-none');
            } else {
                prevBtn.classList.remove('opacity-0', 'pointer-events-none');
            }

            if (activeIndex >= totalSteps - 1) {
                nextBtn.classList.add('opacity-0', 'pointer-events-none');
            } else {
                nextBtn.classList.remove('opacity-0', 'pointer-events-none');
            }
        }
    };

    slider.addEventListener('scroll', () => {
        requestAnimationFrame(updateControls);
    });

    window.scrollSpacesSlider = (direction) => {
        const cardWidth = cards[0].offsetWidth + 16;
        const targetScroll = direction === 'next'
            ? slider.scrollLeft + cardWidth
            : slider.scrollLeft - cardWidth;

        slider.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
        });
    };

    // Initial check
    setTimeout(updateControls, 100);
}


const experienceSlider = document.getElementById('experience-slider');

if (window.innerWidth < 768 && experienceSlider) {

    const slides = experienceSlider.querySelectorAll('.experience-slide');

    let currentSlide = 0;
    let autoRotate;

    const goToSlide = (index) => {

        const slide = slides[index];

        experienceSlider.scrollTo({
            left: slide.offsetLeft - 16,
            behavior: 'smooth'
        });
    };

    const startAutoRotate = () => {

        if (autoRotate) return;

        autoRotate = setInterval(() => {

            currentSlide++;

            if (currentSlide >= slides.length) {
                currentSlide = 0;
            }

            goToSlide(currentSlide);

        }, 3000);
    };

    const stopAutoRotate = () => {
        clearInterval(autoRotate);
        autoRotate = null;
    };

    startAutoRotate();

    // Pause on touch
    experienceSlider.addEventListener('touchstart', () => {
        stopAutoRotate();
    });

    // Resume autoplay
    experienceSlider.addEventListener('touchend', () => {

        setTimeout(() => {
            startAutoRotate();
        }, 2000);
    });

    // Detect active slide
    experienceSlider.addEventListener('scroll', () => {

        let closestIndex = 0;
        let closestDistance = Infinity;

        slides.forEach((slide, index) => {

            const distance = Math.abs(
                experienceSlider.scrollLeft - slide.offsetLeft
            );

            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
            }
        });

        currentSlide = closestIndex;
    });

    experienceSlider._startAutoplay = startAutoRotate;
    experienceSlider._stopAutoplay = stopAutoRotate;
}

const safeInit = (callback) => {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        callback();
    } else {
        window.addEventListener('load', callback);
    }
};

safeInit(() => {

    if (window.innerWidth >= 768) return;

    const slider = document.getElementById('economy-slider');

    if (!slider) return;

    const slides = slider.querySelectorAll('.economy-slide');

    let current = 0;
    let autoplay;

    const startSlider = () => {

        if (autoplay) return;

        autoplay = setInterval(() => {

            current++;

            if (current >= slides.length) {
                current = 0;
            }

            slider.scrollTo({
                left: slides[current].offsetLeft,
                behavior: 'smooth'
            });

        }, 3000);
    };

    const stopSlider = () => {
        clearInterval(autoplay);
        autoplay = null;
    };

    startSlider();

    slider.addEventListener('touchstart', () => {
        stopSlider();
    });

    slider.addEventListener('touchend', () => {

        setTimeout(() => {
            startSlider();
        }, 2000);
    });

    slider._startAutoplay = startSlider;
    slider._stopAutoplay = stopSlider;

});

safeInit(() => {

    if (window.innerWidth >= 768) return;

    const slider = document.getElementById('archive-slider');

    if (!slider) return;

    const slides = slider.querySelectorAll('.archive-slide');

    let current = 0;
    let autoplay;

    const startSlider = () => {

        if (autoplay) return;

        autoplay = setInterval(() => {

            current++;

            if (current >= slides.length) {
                current = 0;
            }

            slider.scrollTo({
                left: slides[current].offsetLeft,
                behavior: 'smooth'
            });

        }, 3000);
    };

    const stopSlider = () => {
        clearInterval(autoplay);
        autoplay = null;
    };

    startSlider();

    slider.addEventListener('touchstart', () => {
        stopSlider();
    });

    slider.addEventListener('touchend', () => {

        setTimeout(() => {
            startSlider();
        }, 2000);
    });

    slider._startAutoplay = startSlider;
    slider._stopAutoplay = stopSlider;

});

safeInit(() => {

    if (window.innerWidth >= 768) return;

    const slider = document.getElementById('addons-slider');

    if (!slider) return;

    const slides = slider.querySelectorAll('.addons-slide');

    let current = 0;
    let autoplay;

    const startSlider = () => {

        if (autoplay) return;

        autoplay = setInterval(() => {

            current++;

            if (current >= slides.length) {
                current = 0;
            }

            slider.scrollTo({
                left: slides[current].offsetLeft,
                behavior: 'smooth'
            });

        }, 3000);
    };

    const stopSlider = () => {
        clearInterval(autoplay);
        autoplay = null;
    };

    startSlider();

    slider.addEventListener('touchstart', () => {
        stopSlider();
    });

    slider.addEventListener('touchend', () => {

        setTimeout(() => {
            startSlider();
        }, 2000);
    });

    slider._startAutoplay = startSlider;
    slider._stopAutoplay = stopSlider;

});

safeInit(() => {

    if (window.innerWidth >= 768) return;

    const slider = document.getElementById('benefits-slider');

    if (!slider) return;

    const slides = slider.querySelectorAll('.benefit-slide');

    let current = 0;
    let autoplay;

    const startSlider = () => {

        if (autoplay) return;

        autoplay = setInterval(() => {

            current++;

            if (current >= slides.length) {
                current = 0;
            }

            slider.scrollTo({
                left: slides[current].offsetLeft,
                behavior: 'smooth'
            });

        }, 3000);
    };

    const stopSlider = () => {
        clearInterval(autoplay);
        autoplay = null;
    };

    startSlider();

    slider.addEventListener('touchstart', () => {
        stopSlider();
    });

    slider.addEventListener('touchend', () => {

        setTimeout(() => {
            startSlider();
        }, 2000);
    });

    slider._startAutoplay = startSlider;
    slider._stopAutoplay = stopSlider;

});


safeInit(() => {

    if (window.innerWidth >= 768) return;

    const slider = document.getElementById('voice-slider');

    if (!slider) return;

    const slides = slider.querySelectorAll('.voice-slide');

    let current = 0;
    let autoplay;

    const startSlider = () => {

        if (autoplay) return;

        autoplay = setInterval(() => {

            current++;

            if (current >= slides.length) {
                current = 0;
            }

            slider.scrollTo({
                left: slides[current].offsetLeft,
                behavior: 'smooth'
            });

        }, 3000);
    };

    const stopSlider = () => {
        clearInterval(autoplay);
        autoplay = null;
    };

    startSlider();

    slider.addEventListener('touchstart', () => {
        stopSlider();
    });

    slider.addEventListener('touchend', () => {

        setTimeout(() => {
            startSlider();
        }, 2000);
    });

    slider._startAutoplay = startSlider;
    slider._stopAutoplay = stopSlider;

});

// Central Performance Optimizer for Offscreen Animations & Loops
const initOffscreenOptimizer = () => {
    // 1. Inject global CSS helper for pausing CSS animations and optimizing iOS SVG layout/filters on mobile
    const style = document.createElement('style');
    style.innerHTML = `
        .paused-animations, .paused-animations * {
            animation-play-state: paused !important;
            -webkit-animation-play-state: paused !important;
        }
        
        /* Mobile Performance Optimizations to prevent CPU/GPU memory reloads and layout thrashing */
        @media (max-width: 1023px) {
            /* Simplify active lines: Disable the expensive SVG blur filters */
            .system-line.active-line {
                animation: activeLineMobile 1.5s ease-in-out infinite !important;
                filter: none !important;
                -webkit-filter: none !important;
            }
            
            /* Simplify node breathing: Replace scaling (transform) with simple opacity shifts to avoid SVG rasterization thrashing */
            .system-node-group:not(.active) .node-content-group {
                animation: nodeBreathMobile 4s ease-in-out infinite !important;
                transform: none !important;
                -webkit-transform: none !important;
            }
            
            /* Simplify active node pulsing: Replace scale pulse with standard opacity breathing */
            .system-node-group.active .node-content-group {
                animation: activeNodePulseMobile 2s ease-in-out infinite !important;
                transform: none !important;
                -webkit-transform: none !important;
            }
            
            /* Disable heavy dynamic drop-shadow on node circles (the main cause of iOS GPU OOM/reloads) */
            .system-node-group.active .node-circle {
                filter: none !important;
                -webkit-filter: none !important;
                stroke-width: 4px !important;
                stroke: #facc15 !important; /* Emphasize active node with strong border highlight instead of heavy shadow */
            }
            
            /* Disable dynamic SVG celebration rings on mobile */
            .celebration-ring {
                display: none !important;
                animation: none !important;
            }
            
            @keyframes activeLineMobile {
                0%, 100% {
                    stroke-opacity: 0.5;
                    stroke-width: 3.5px;
                }
                50% {
                    stroke-opacity: 0.95;
                    stroke-width: 4.5px;
                }
            }
            @keyframes nodeBreathMobile {
                0%, 100% {
                    opacity: 0.6;
                }
                50% {
                    opacity: 1;
                }
            }
            @keyframes activeNodePulseMobile {
                0%, 100% {
                    opacity: 0.85;
                }
                50% {
                    opacity: 1;
                }
            }
        }
    `;
    document.head.appendChild(style);

    // 2. IntersectionObserver Callback
    const observerCallback = (entries) => {
        entries.forEach(entry => {
            const target = entry.target;
            const isVisible = entry.isIntersecting;

            // Pause/Resume HTML5 video playbacks
            const videos = target.querySelectorAll('video');
            videos.forEach(video => {
                if (isVisible) {
                    if (video.paused && video.autoplay) {
                        video.play().catch(() => { });
                    }
                } else {
                    if (!video.paused) {
                        video.pause();
                    }
                }
            });

            // Pause/Resume CSS Animations using the helper class
            if (isVisible) {
                target.classList.remove('paused-animations');
            } else {
                target.classList.add('paused-animations');
            }

            // Pause/Resume Javascript autoplay routines
            if (isVisible) {
                if (typeof target._startAutoplay === 'function') {
                    target._startAutoplay();
                }
            } else {
                if (typeof target._stopAutoplay === 'function') {
                    target._stopAutoplay();
                }
            }
        });
    };

    const optimizerObserver = new IntersectionObserver(observerCallback, {
        root: null,
        threshold: 0.05,
        rootMargin: '100px' // Start playing slightly before entering the viewport for seamless UX
    });

    // 3. Register target elements
    const elementsToObserve = [
        document.getElementById('data-stream-container'),
        document.getElementById('dynamic-cards-wrapper'),
        document.getElementById('artifact-step-display'),
        document.getElementById('artifact-display'),
        document.getElementById('token-economy'),
        document.getElementById('experience-slider'),
        document.getElementById('economy-slider'),
        document.getElementById('archive-slider'),
        document.getElementById('addons-slider'),
        document.getElementById('benefits-slider'),
        document.getElementById('voice-slider')
    ].filter(Boolean);

    elementsToObserve.forEach(el => optimizerObserver.observe(el));
};

// Start the optimizer after page has fully loaded
safeInit(() => {
    setTimeout(initOffscreenOptimizer, 200);
});